var _defs, _path, _path2, _path3, _rect, _polygon, _rect2, _rect3, _rect4, _rect5, _rect6, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _polygon2, _path461, _path462, _path463, _polygon3, _path464, _path465, _path466, _polygon4, _rect7, _path467, _path468, _path469, _path470, _path471, _path472, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _polygon5, _path473, _path474, _rect17, _path475, _path476, _polygon6, _rect18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMosharek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 561.53 243.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc8b2;}.cls-2,.cls-7{fill:#fff;}.cls-3,.cls-5{fill:#fe4800;}.cls-4,.cls-6{fill:#343434;}.cls-4,.cls-5,.cls-7{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.15,475.84s-98.43-25.77-82.86-97.16c12.12-55.58,81.16-78.74,81.16-78.74s42.4-19.67,92.29,5.41,111.67-9.26,111.67-9.26,201.49-94.3,257.46,22.25C787.38,436,672.12,469.61,672.12,469.61s-21.81,12.83-87.93,4.28-97.27-11.76-152.8-2.14S337.59,493.83,271.15,475.84Z",
    transform: "translate(-186.62 -241.03)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M608.5,275.22,605,269s-5.67-4.22-5.62-5.07-6.87-3.17-6.87-3.17l-8.37-.67-8,2.05s-6.86,4.52-7,4.71-3.9,5.33-4.08,5.66-2.52,8.24-2.52,8.24l.74,6.8,2.58,7.16,6.06,7.35,7,3.92,8.66,1.25,7.47-1.7,4.72-2.92,5.3-5.6,2-2.3,2.76-7.16v-5.09ZM605,286.56,602.18,293l-3.12,4.1-3.65,2.67-6.95,2.32-6.6-.61-7.48-3.13-4.9-6.24-1.8-6.33-.25-6.5,3.29-7.13s5-4.19,5.31-4.63,5.83-2.77,5.83-2.77l7.17.48,6.82,2,4.1,4.05L603.6,276l1.44,5.17Z",
    transform: "translate(-186.62 -241.03)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.68,461.27l-.5-27.66,10-9.7,2.88.71.51-7.53h9.58V424l4.42.64,5.23-2V373.52l4.17-.36-.56-6h3.29l.16-8.15,5.69-.3,4.25,3.38v4.36l2,1.42.31,4.92,3.55.71,5.68,3-1.21-30.9L275,334l7.53-.36V328l7.33-.72.61-4.54,4.67-4.73,6.34.11-1.43,9.16,2.91.16-.2,6.18,4-.35-.71-25.42h8.71l.73-8.24,4.52-.59-.9-9.61,5.93,0h29.07L355,299l3.49,1,.71,7.12,8.52.94v14.67h5.81l0-6.26h12.19V322l6.36.71-.44,13.59.77,16.79,1,3.18h12.08l.71,5.16,2.18.35,13.43,7,1,30.08s.69-2.44,1.48-2.11,6.85,1.22,6.85,1.22v7.74l1.87.46.53,6.61h3.22l.36,13,2.48.35v-7.06l2.57.31-.34-6.62,5.51-.38v7.16l2.07,0,5.34,2.31-.39,4.67,3.78.71L477,436.9V389.72l2.06-.2.79-9,2-.55-.66-5.2,5.17-.68v5.79l1.16-.18,15.56,9.56.08,11.52,12.42,5.51,3.69.59-.51-6.1,5.64-3.81,5,0-1.27-7.47,11.58.64.44,6.83,1.58,0,.39,10.39,2.41.2,1.27,28.74h4.13l.71-4.46,4.78.07v-4l5.32-2.7,5.94-.64-.83-6.84,4.18-.08.63-4.33,13.25-.57-.32,11.82,3.44.64v5.4h3.73l-.63-18.95,8.1.63v-10l25.57-21.64h3.75l-.34-6.49,4.86-3.51,4.56.18v-10.4h10.61l.47,11.37h2.61l.57,8.53h3.53l.32-32.93,1.22-.16.25-30.38,2.4-.56,1.27-9.33,2.64-.64v-3.61l2.89-.63V291.86l2.88-.22,3.28-7.63,0-8.29-.29-8.78.64-.64,8.1-.05-1.07,8.05.64,9.5,2,7.84,3,.85.08,10.32h3.53l.63,4.25h2l.77.59-.18,8.8,2.61.26V347l2.26.31.44,19.26h3.14l-.37-9.1,1.51-.13v-6l8.64.08.45,5.67h2.23l6.86,3,.28,6.64,4.44.09v12.2l2.61,0,.87,10.13h-3.48l5.32,22,3.29.8,2.26,1.82V461Z",
    transform: "translate(-186.62 -241.03)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 196.11,
    y: 172.13,
    width: 11.14,
    height: 47.18
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "328.55 219.18 295.28 219.18 295.28 149.13 328.79 166.57 328.55 219.18"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 404.4,
    y: 170.7,
    width: 7.78,
    height: 49.23
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 485.23,
    y: 94.76,
    width: 7.24,
    height: 123.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 537.19,
    y: 148.77,
    width: 4.05,
    height: 70.52
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 44.46,
    y: 171.49,
    width: 6.65,
    height: 48.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.38,
    y: 95.89,
    width: 13.16,
    height: 123.29
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414.6,413.51,394.05,426.3a.71.71,0,0,1-1-.23.72.72,0,0,1,.23-1L414,412.19a.76.76,0,0,1,.38-.11h22.76a.71.71,0,0,1,.71.72v47.76a.71.71,0,0,1-1.42,0V413.51Z",
    transform: "translate(-186.62 -241.03)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.22,374.23v86.33a.72.72,0,0,1-1.43,0v-87a.71.71,0,0,1,.71-.71h22.76a.7.7,0,0,1,.38.1l20.72,12.9a.71.71,0,1,1-.75,1.21l-20.55-12.79Z",
    transform: "translate(-186.62 -241.03)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.84,460.56V299.29a.71.71,0,0,1,.71-.72h43.67a.71.71,0,0,1,.71.72V460.56a.71.71,0,0,1-.71.71H315.3l0,0h0l0,0a.7.7,0,0,1-.37-.62Zm1.42-.72h42.25V300H316.26V459.84Z",
    transform: "translate(-186.62 -241.03)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M320.65,290.08v9.21a.72.72,0,0,1-1.43,0v-9.92a.71.71,0,0,1,.71-.71h34.91a.71.71,0,0,1,.71.71v9.92a.72.72,0,0,1-1.43,0v-9.21Z",
    transform: "translate(-186.62 -241.03)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M326.55,274.54v14.83a.72.72,0,0,1-1.43,0V273.82a.71.71,0,0,1,.71-.71h23.11a.71.71,0,0,1,.71.71v15.55a.72.72,0,0,1-1.43,0V274.54Z",
    transform: "translate(-186.62 -241.03)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M325.22,273.47a.7.7,0,0,0,0,.71.7.7,0,0,0,.61.36h23.11a.7.7,0,0,0,.61-.36.7.7,0,0,0,0-.71L338,253.63a.72.72,0,0,0-1.23,0l-11.55,19.84Zm1.85-.36H347.7L337.38,255.4l-10.31,17.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.06,338.34H359.22a.72.72,0,0,1,0-1.43h12.55a.71.71,0,0,1,.72.71V460.56a.71.71,0,0,1-.72.71H359.22a.72.72,0,0,1,0-1.43h11.84V338.34Z",
    transform: "translate(-186.62 -241.03)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M303.71,459.84h11.84a.72.72,0,0,1,0,1.43H303a.71.71,0,0,1-.72-.71V337.62a.71.71,0,0,1,.72-.71h12.55a.72.72,0,0,1,0,1.43H303.71v121.5Z",
    transform: "translate(-186.62 -241.03)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M367.21,308.55h-8a.72.72,0,0,1,0-1.43h8.71a.71.71,0,0,1,.71.72v29.78a.72.72,0,1,1-1.43,0V308.55Z",
    transform: "translate(-186.62 -241.03)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M307.56,308.55v29.07a.72.72,0,1,1-1.43,0V307.84a.71.71,0,0,1,.71-.72h8.71a.72.72,0,0,1,0,1.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M393,413.51h-21.2a.72.72,0,0,1,0-1.43h21.91a.71.71,0,0,1,.71.72v47.76a.71.71,0,0,1-.71.71H371.77a.72.72,0,0,1,0-1.43H393V413.51Z",
    transform: "translate(-186.62 -241.03)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M281.68,459.84h21.2a.72.72,0,0,1,0,1.43H281a.71.71,0,0,1-.71-.71V412.8a.71.71,0,0,1,.71-.72h21.91a.72.72,0,0,1,0,1.43h-21.2v46.33Z",
    transform: "translate(-186.62 -241.03)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M382,412.8v47.76a.72.72,0,0,0,1.43,0V412.8a.72.72,0,1,0-1.43,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M291.21,412.8v47.76a.72.72,0,0,0,1.43,0V412.8a.72.72,0,1,0-1.43,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.19,382.85h-7.42a.72.72,0,0,1,0-1.43h8.13a.72.72,0,0,1,.72.72V412.8a.72.72,0,0,1-1.43,0V382.85Z",
    transform: "translate(-186.62 -241.03)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M295.46,382.85V412.8a.72.72,0,0,1-1.43,0V382.14a.72.72,0,0,1,.72-.72h8.13a.72.72,0,0,1,0,1.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M335,307.8V430.86a.36.36,0,1,1-.71,0V307.44a.36.36,0,0,1,.36-.35h5.57a.36.36,0,0,1,.36.35V430.86a.36.36,0,1,1-.71,0V307.8Z",
    transform: "translate(-186.62 -241.03)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M335,293.11v6.14a.36.36,0,0,1-.71,0v-6.5a.36.36,0,0,1,.36-.35h5.57a.36.36,0,0,1,.36.35v6.5a.36.36,0,0,1-.71,0v-6.14Z",
    transform: "translate(-186.62 -241.03)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M335,277.94v11.23a.36.36,0,1,1-.71,0V277.59a.36.36,0,0,1,.36-.36h5.57a.36.36,0,0,1,.36.36v11.58a.36.36,0,1,1-.71,0V277.94Z",
    transform: "translate(-186.62 -241.03)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M323.55,307.8V460.56a.36.36,0,0,1-.36.35.35.35,0,0,1-.35-.35V307.44a.35.35,0,0,1,.35-.35h5.58a.35.35,0,0,1,.35.35V430.86a.36.36,0,1,1-.71,0V307.8Z",
    transform: "translate(-186.62 -241.03)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M323.55,293.11v6.14a.36.36,0,0,1-.36.35.35.35,0,0,1-.35-.35v-6.5a.35.35,0,0,1,.35-.35h5.58a.35.35,0,0,1,.35.35v6.43a.36.36,0,1,1-.71,0v-6.07Z",
    transform: "translate(-186.62 -241.03)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M346.36,307.8V430.86a.36.36,0,1,1-.71,0V307.44a.35.35,0,0,1,.35-.35h5.58a.35.35,0,0,1,.35.35V460.56a.36.36,0,0,1-.71,0V307.8Z",
    transform: "translate(-186.62 -241.03)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M346.36,293.11v6.07a.36.36,0,1,1-.71,0v-6.43a.35.35,0,0,1,.35-.35h5.58a.35.35,0,0,1,.35.35v6.69a.36.36,0,1,1-.71,0v-6.33Z",
    transform: "translate(-186.62 -241.03)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M365.5,312.78a.36.36,0,0,0-.35-.36H362a.36.36,0,0,0-.36.36v3.14a.36.36,0,0,0,.36.36h3.15a.36.36,0,0,0,.35-.36v-3.14Zm-3.14.35v2.44h2.43v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M377.77,388.24a.36.36,0,0,0-.36-.36h-3.14a.36.36,0,0,0-.36.36v3.15a.36.36,0,0,0,.36.35h3.14a.36.36,0,0,0,.36-.35v-3.15Zm-3.15.36V391h2.44V388.6Z",
    transform: "translate(-186.62 -241.03)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.29,415.52a.36.36,0,0,0-.36-.36h-3.14a.36.36,0,0,0-.36.36v3.14a.36.36,0,0,0,.36.36h3.14a.36.36,0,0,0,.36-.36v-3.14Zm-3.15.35v2.44h2.44v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.33,415.52a.36.36,0,0,0-.35-.36h-3.15a.35.35,0,0,0-.35.36v3.14a.35.35,0,0,0,.35.36H288a.36.36,0,0,0,.35-.36v-3.14Zm-3.14.35v2.44h2.43v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M390,415.52a.36.36,0,0,0-.36-.36h-3.15a.36.36,0,0,0-.35.36v3.14a.36.36,0,0,0,.35.36h3.15a.36.36,0,0,0,.36-.36v-3.14Zm-3.15.35v2.44h2.43v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299,415.52a.36.36,0,0,0-.35-.36h-3.15a.36.36,0,0,0-.36.36v3.14a.36.36,0,0,0,.36.36h3.15a.36.36,0,0,0,.35-.36v-3.14Zm-3.14.35v2.44h2.43v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.29,437.93a.36.36,0,0,0-.36-.35h-3.14a.36.36,0,0,0-.36.35v3.15a.36.36,0,0,0,.36.36h3.14a.36.36,0,0,0,.36-.36v-3.15Zm-3.15.36v2.43h2.44v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.33,437.93a.35.35,0,0,0-.35-.35h-3.15a.35.35,0,0,0-.35.35v3.15a.35.35,0,0,0,.35.36H288a.36.36,0,0,0,.35-.36v-3.15Zm-3.14.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M390,437.93a.36.36,0,0,0-.36-.35h-3.15a.35.35,0,0,0-.35.35v3.15a.36.36,0,0,0,.35.36h3.15a.36.36,0,0,0,.36-.36v-3.15Zm-3.15.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299,437.93a.35.35,0,0,0-.35-.35h-3.15a.36.36,0,0,0-.36.35v3.15a.36.36,0,0,0,.36.36h3.15a.36.36,0,0,0,.35-.36v-3.15Zm-3.14.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.29,421.09a.36.36,0,0,0-.36-.36h-3.14a.36.36,0,0,0-.36.36v3.15a.36.36,0,0,0,.36.35h3.14a.36.36,0,0,0,.36-.35v-3.15Zm-3.15.36v2.43h2.44v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.33,421.09a.36.36,0,0,0-.35-.36h-3.15a.35.35,0,0,0-.35.36v3.15a.35.35,0,0,0,.35.35H288a.35.35,0,0,0,.35-.35v-3.15Zm-3.14.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M390,421.09a.36.36,0,0,0-.36-.36h-3.15a.36.36,0,0,0-.35.36v3.15a.35.35,0,0,0,.35.35h3.15a.36.36,0,0,0,.36-.35v-3.15Zm-3.15.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299,421.09a.36.36,0,0,0-.35-.36h-3.15a.36.36,0,0,0-.36.36v3.15a.36.36,0,0,0,.36.35h3.15a.35.35,0,0,0,.35-.35v-3.15Zm-3.14.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.29,443.51a.36.36,0,0,0-.36-.36h-3.14a.36.36,0,0,0-.36.36v3.15a.36.36,0,0,0,.36.35h3.14a.36.36,0,0,0,.36-.35v-3.15Zm-3.15.35v2.44h2.44v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.33,443.51a.36.36,0,0,0-.35-.36h-3.15a.35.35,0,0,0-.35.36v3.15a.35.35,0,0,0,.35.35H288a.35.35,0,0,0,.35-.35v-3.15Zm-3.14.35v2.44h2.43v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M390,443.51a.36.36,0,0,0-.36-.36h-3.15a.36.36,0,0,0-.35.36v3.15a.35.35,0,0,0,.35.35h3.15a.36.36,0,0,0,.36-.35v-3.15Zm-3.15.35v2.44h2.43v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299,443.51a.36.36,0,0,0-.35-.36h-3.15a.36.36,0,0,0-.36.36v3.15a.36.36,0,0,0,.36.35h3.15a.35.35,0,0,0,.35-.35v-3.15Zm-3.14.35v2.44h2.43v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.29,426.67a.36.36,0,0,0-.36-.36h-3.14a.36.36,0,0,0-.36.36v3.14a.36.36,0,0,0,.36.36h3.14a.36.36,0,0,0,.36-.36v-3.14Zm-3.15.35v2.44h2.44V427Z",
    transform: "translate(-186.62 -241.03)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.33,426.67a.36.36,0,0,0-.35-.36h-3.15a.35.35,0,0,0-.35.36v3.14a.35.35,0,0,0,.35.36H288a.36.36,0,0,0,.35-.36v-3.14Zm-3.14.35v2.44h2.43V427Z",
    transform: "translate(-186.62 -241.03)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M390,426.67a.36.36,0,0,0-.36-.36h-3.15a.36.36,0,0,0-.35.36v3.14a.36.36,0,0,0,.35.36h3.15a.36.36,0,0,0,.36-.36v-3.14Zm-3.15.35v2.44h2.43V427Z",
    transform: "translate(-186.62 -241.03)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299,426.67a.36.36,0,0,0-.35-.36h-3.15a.36.36,0,0,0-.36.36v3.14a.36.36,0,0,0,.36.36h3.15a.36.36,0,0,0,.35-.36v-3.14Zm-3.14.35v2.44h2.43V427Z",
    transform: "translate(-186.62 -241.03)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.29,449.08a.36.36,0,0,0-.36-.35h-3.14a.36.36,0,0,0-.36.35v3.15a.36.36,0,0,0,.36.36h3.14a.36.36,0,0,0,.36-.36v-3.15Zm-3.15.36v2.43h2.44v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.33,449.08a.35.35,0,0,0-.35-.35h-3.15a.35.35,0,0,0-.35.35v3.15a.35.35,0,0,0,.35.36H288a.36.36,0,0,0,.35-.36v-3.15Zm-3.14.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M390,449.08a.36.36,0,0,0-.36-.35h-3.15a.35.35,0,0,0-.35.35v3.15a.36.36,0,0,0,.35.36h3.15a.36.36,0,0,0,.36-.36v-3.15Zm-3.15.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299,449.08a.35.35,0,0,0-.35-.35h-3.15a.36.36,0,0,0-.36.35v3.15a.36.36,0,0,0,.36.36h3.15a.36.36,0,0,0,.35-.36v-3.15Zm-3.14.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.29,432.27a.36.36,0,0,0-.36-.35h-3.14a.36.36,0,0,0-.36.35v3.15a.36.36,0,0,0,.36.36h3.14a.36.36,0,0,0,.36-.36v-3.15Zm-3.15.36v2.43h2.44v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.33,432.27a.35.35,0,0,0-.35-.35h-3.15a.35.35,0,0,0-.35.35v3.15a.35.35,0,0,0,.35.36H288a.36.36,0,0,0,.35-.36v-3.15Zm-3.14.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M390,432.27a.36.36,0,0,0-.36-.35h-3.15a.35.35,0,0,0-.35.35v3.15a.36.36,0,0,0,.35.36h3.15a.36.36,0,0,0,.36-.36v-3.15Zm-3.15.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299,432.27a.35.35,0,0,0-.35-.35h-3.15a.36.36,0,0,0-.36.35v3.15a.36.36,0,0,0,.36.36h3.15a.36.36,0,0,0,.35-.36v-3.15Zm-3.14.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.29,454.69a.36.36,0,0,0-.36-.35h-3.14a.36.36,0,0,0-.36.35v3.15a.35.35,0,0,0,.36.35h3.14a.35.35,0,0,0,.36-.35v-3.15Zm-3.15.36v2.43h2.44v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.33,454.69a.35.35,0,0,0-.35-.35h-3.15a.35.35,0,0,0-.35.35v3.15a.34.34,0,0,0,.35.35H288a.35.35,0,0,0,.35-.35v-3.15Zm-3.14.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M390,454.69a.36.36,0,0,0-.36-.35h-3.15a.35.35,0,0,0-.35.35v3.15a.35.35,0,0,0,.35.35h3.15a.35.35,0,0,0,.36-.35v-3.15Zm-3.15.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299,454.69a.35.35,0,0,0-.35-.35h-3.15a.36.36,0,0,0-.36.35v3.15a.35.35,0,0,0,.36.35h3.15a.35.35,0,0,0,.35-.35v-3.15Zm-3.14.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M300.74,388.24a.36.36,0,0,0-.36-.36h-3.14a.36.36,0,0,0-.36.36v3.15a.36.36,0,0,0,.36.35h3.14a.36.36,0,0,0,.36-.35v-3.15Zm-3.15.36V391H300V388.6Z",
    transform: "translate(-186.62 -241.03)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.13,312.78a.36.36,0,0,0-.36-.36h-3.15a.36.36,0,0,0-.35.36v3.14a.36.36,0,0,0,.35.36h3.15a.36.36,0,0,0,.36-.36v-3.14Zm-3.15.35v2.44h2.43v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M365.5,318.35a.35.35,0,0,0-.35-.35H362a.36.36,0,0,0-.36.35v3.15a.36.36,0,0,0,.36.36h3.15a.36.36,0,0,0,.35-.36v-3.15Zm-3.14.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M377.77,393.82a.36.36,0,0,0-.36-.36h-3.14a.36.36,0,0,0-.36.36V397a.36.36,0,0,0,.36.36h3.14a.36.36,0,0,0,.36-.36v-3.14Zm-3.15.35v2.44h2.44v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M300.74,393.82a.36.36,0,0,0-.36-.36h-3.14a.36.36,0,0,0-.36.36V397a.36.36,0,0,0,.36.36h3.14a.36.36,0,0,0,.36-.36v-3.14Zm-3.15.35v2.44H300v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.13,318.35a.36.36,0,0,0-.36-.35h-3.15a.35.35,0,0,0-.35.35v3.15a.36.36,0,0,0,.35.36h3.15a.36.36,0,0,0,.36-.36v-3.15Zm-3.15.36v2.43h2.43v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M365.5,323.93a.36.36,0,0,0-.35-.36H362a.36.36,0,0,0-.36.36v3.14a.36.36,0,0,0,.36.36h3.15a.36.36,0,0,0,.35-.36v-3.14Zm-3.14.35v2.44h2.43v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M377.77,399.39a.36.36,0,0,0-.36-.36h-3.14a.36.36,0,0,0-.36.36v3.15a.36.36,0,0,0,.36.35h3.14a.36.36,0,0,0,.36-.35v-3.15Zm-3.15.36v2.43h2.44v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M300.74,399.39a.36.36,0,0,0-.36-.36h-3.14a.36.36,0,0,0-.36.36v3.15a.36.36,0,0,0,.36.35h3.14a.36.36,0,0,0,.36-.35v-3.15Zm-3.15.36v2.43H300v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.13,323.93a.36.36,0,0,0-.36-.36h-3.15a.36.36,0,0,0-.35.36v3.14a.36.36,0,0,0,.35.36h3.15a.36.36,0,0,0,.36-.36v-3.14Zm-3.15.35v2.44h2.43v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M365.5,329.54a.36.36,0,0,0-.35-.36H362a.36.36,0,0,0-.36.36v3.14a.36.36,0,0,0,.36.36h3.15a.36.36,0,0,0,.35-.36v-3.14Zm-3.14.35v2.44h2.43v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M377.77,405a.36.36,0,0,0-.36-.36h-3.14a.36.36,0,0,0-.36.36v3.15a.36.36,0,0,0,.36.35h3.14a.36.36,0,0,0,.36-.35V405Zm-3.15.36v2.43h2.44v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M300.74,405a.36.36,0,0,0-.36-.36h-3.14a.36.36,0,0,0-.36.36v3.15a.36.36,0,0,0,.36.35h3.14a.36.36,0,0,0,.36-.35V405Zm-3.15.36v2.43H300v-2.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,340.51a.35.35,0,0,0-.35-.35h-5.2a.36.36,0,0,0-.36.35v5.2a.36.36,0,0,0,.36.36h5.2a.36.36,0,0,0,.35-.36v-5.2Zm-5.2.36v4.49h4.49v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,340.51a.36.36,0,0,0-.36-.35h-5.2a.35.35,0,0,0-.35.35v5.2a.36.36,0,0,0,.35.36h5.2a.36.36,0,0,0,.36-.36v-5.2Zm-5.2.36v4.49h4.48v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,358.23a.36.36,0,0,0-.35-.36h-5.2a.36.36,0,0,0-.36.36v5.2a.36.36,0,0,0,.36.36h5.2a.36.36,0,0,0,.35-.36v-5.2Zm-5.2.36v4.48h4.49v-4.48Z",
    transform: "translate(-186.62 -241.03)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,358.23a.36.36,0,0,0-.36-.36h-5.2a.36.36,0,0,0-.35.36v5.2a.36.36,0,0,0,.35.36h5.2a.36.36,0,0,0,.36-.36v-5.2Zm-5.2.36v4.48h4.48v-4.48Z",
    transform: "translate(-186.62 -241.03)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,393.66a.35.35,0,0,0-.35-.35h-5.2a.36.36,0,0,0-.36.35v5.2a.36.36,0,0,0,.36.36h5.2a.36.36,0,0,0,.35-.36v-5.2Zm-5.2.36v4.48h4.49V394Z",
    transform: "translate(-186.62 -241.03)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,393.66a.36.36,0,0,0-.36-.35h-5.2a.35.35,0,0,0-.35.35v5.2a.36.36,0,0,0,.35.36h5.2a.36.36,0,0,0,.36-.36v-5.2ZM307,394v4.48h4.48V394Z",
    transform: "translate(-186.62 -241.03)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,429.09a.35.35,0,0,0-.35-.35h-5.2a.36.36,0,0,0-.36.35v5.2a.36.36,0,0,0,.36.36h5.2a.36.36,0,0,0,.35-.36v-5.2Zm-5.2.36v4.49h4.49v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,429.09a.36.36,0,0,0-.36-.35h-5.2a.35.35,0,0,0-.35.35v5.2a.36.36,0,0,0,.35.36h5.2a.36.36,0,0,0,.36-.36v-5.2Zm-5.2.36v4.49h4.48v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,376a.36.36,0,0,0-.35-.36h-5.2a.36.36,0,0,0-.36.36v5.19a.36.36,0,0,0,.36.36h5.2a.36.36,0,0,0,.35-.36V376Zm-5.2.35v4.49h4.49V376.3Z",
    transform: "translate(-186.62 -241.03)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,376a.36.36,0,0,0-.36-.36h-5.2a.36.36,0,0,0-.35.36v5.19a.36.36,0,0,0,.35.36h5.2a.36.36,0,0,0,.36-.36V376Zm-5.2.35v4.49h4.48V376.3Z",
    transform: "translate(-186.62 -241.03)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,411.38a.36.36,0,0,0-.35-.36h-5.2a.36.36,0,0,0-.36.36v5.2a.36.36,0,0,0,.36.35h5.2a.35.35,0,0,0,.35-.35v-5.2Zm-5.2.35v4.49h4.49v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,411.38a.36.36,0,0,0-.36-.36h-5.2a.36.36,0,0,0-.35.36v5.2a.35.35,0,0,0,.35.35h5.2a.36.36,0,0,0,.36-.35v-5.2Zm-5.2.35v4.49h4.48v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,446.81a.36.36,0,0,0-.35-.36h-5.2a.36.36,0,0,0-.36.36V452a.36.36,0,0,0,.36.35h5.2a.35.35,0,0,0,.35-.35v-5.2Zm-5.2.36v4.48h4.49v-4.48Z",
    transform: "translate(-186.62 -241.03)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,446.81a.36.36,0,0,0-.36-.36h-5.2a.36.36,0,0,0-.35.36V452a.35.35,0,0,0,.35.35h5.2a.36.36,0,0,0,.36-.35v-5.2Zm-5.2.36v4.48h4.48v-4.48Z",
    transform: "translate(-186.62 -241.03)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,349.42a.35.35,0,0,0-.35-.35h-5.2a.36.36,0,0,0-.36.35v5.2a.36.36,0,0,0,.36.36h5.2a.36.36,0,0,0,.35-.36v-5.2Zm-5.2.36v4.49h4.49v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,349.42a.36.36,0,0,0-.36-.35h-5.2a.35.35,0,0,0-.35.35v5.2a.36.36,0,0,0,.35.36h5.2a.36.36,0,0,0,.36-.36v-5.2Zm-5.2.36v4.49h4.48v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,367.14a.36.36,0,0,0-.35-.36h-5.2a.36.36,0,0,0-.36.36v5.2a.36.36,0,0,0,.36.35h5.2a.35.35,0,0,0,.35-.35v-5.2Zm-5.2.36V372h4.49V367.5Z",
    transform: "translate(-186.62 -241.03)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,367.14a.36.36,0,0,0-.36-.36h-5.2a.36.36,0,0,0-.35.36v5.2a.35.35,0,0,0,.35.35h5.2a.36.36,0,0,0,.36-.35v-5.2Zm-5.2.36V372h4.48V367.5Z",
    transform: "translate(-186.62 -241.03)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,402.57a.36.36,0,0,0-.35-.36h-5.2a.36.36,0,0,0-.36.36v5.2a.36.36,0,0,0,.36.36h5.2a.36.36,0,0,0,.35-.36v-5.2Zm-5.2.36v4.48h4.49v-4.48Z",
    transform: "translate(-186.62 -241.03)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,402.57a.36.36,0,0,0-.36-.36h-5.2a.36.36,0,0,0-.35.36v5.2a.36.36,0,0,0,.35.36h5.2a.36.36,0,0,0,.36-.36v-5.2Zm-5.2.36v4.48h4.48v-4.48Z",
    transform: "translate(-186.62 -241.03)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,438a.35.35,0,0,0-.35-.35h-5.2a.36.36,0,0,0-.36.35v5.2a.36.36,0,0,0,.36.36h5.2a.36.36,0,0,0,.35-.36V438Zm-5.2.36v4.48h4.49v-4.48Z",
    transform: "translate(-186.62 -241.03)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,438a.36.36,0,0,0-.36-.35h-5.2a.35.35,0,0,0-.35.35v5.2a.36.36,0,0,0,.35.36h5.2a.36.36,0,0,0,.36-.36V438Zm-5.2.36v4.48h4.48v-4.48Z",
    transform: "translate(-186.62 -241.03)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,384.86a.36.36,0,0,0-.35-.36h-5.2a.36.36,0,0,0-.36.36v5.19a.36.36,0,0,0,.36.36h5.2a.36.36,0,0,0,.35-.36v-5.19Zm-5.2.35v4.49h4.49v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,384.86a.36.36,0,0,0-.36-.36h-5.2a.36.36,0,0,0-.35.36v5.19a.36.36,0,0,0,.35.36h5.2a.36.36,0,0,0,.36-.36v-5.19Zm-5.2.35v4.49h4.48v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,420.29a.36.36,0,0,0-.35-.36h-5.2a.36.36,0,0,0-.36.36v5.2a.36.36,0,0,0,.36.35h5.2a.35.35,0,0,0,.35-.35v-5.2Zm-5.2.35v4.49h4.49v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,420.29a.36.36,0,0,0-.36-.36h-5.2a.36.36,0,0,0-.35.36v5.2a.35.35,0,0,0,.35.35h5.2a.36.36,0,0,0,.36-.35v-5.2Zm-5.2.35v4.49h4.48v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.45,455.72a.36.36,0,0,0-.35-.36h-5.2a.36.36,0,0,0-.36.36v5.2a.36.36,0,0,0,.36.35h5.2a.35.35,0,0,0,.35-.35v-5.2Zm-5.2.35v4.49h4.49v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.23,455.72a.36.36,0,0,0-.36-.36h-5.2a.36.36,0,0,0-.35.36v5.2a.35.35,0,0,0,.35.35h5.2a.36.36,0,0,0,.36-.35v-5.2Zm-5.2.35v4.49h4.48v-4.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.13,329.54a.36.36,0,0,0-.36-.36h-3.15a.36.36,0,0,0-.35.36v3.14a.36.36,0,0,0,.35.36h3.15a.36.36,0,0,0,.36-.36v-3.14Zm-3.15.35v2.44h2.43v-2.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.85,461.63h299a.72.72,0,0,0,0-1.43h-299a.72.72,0,0,0,0,1.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210,467.8H474.63a.71.71,0,0,0,0-1.42H210a.71.71,0,1,0,0,1.42Z",
    transform: "translate(-186.62 -241.03)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M345.82,474.23H455.34a.71.71,0,0,0,0-1.42H345.82a.71.71,0,0,0,0,1.42Z",
    transform: "translate(-186.62 -241.03)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M326.19,431.22v29.34a.36.36,0,0,1-.71,0v-29.7a.36.36,0,0,1,.35-.36h23.11a.36.36,0,0,1,.35.36v29.7a.36.36,0,0,1-.71,0V431.22Z",
    transform: "translate(-186.62 -241.03)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M328.37,433.06v27.5a.36.36,0,0,1-.71,0V432.71a.36.36,0,0,1,.36-.36h18.73a.36.36,0,0,1,.36.36v27.85a.36.36,0,0,1-.72,0v-27.5Z",
    transform: "translate(-186.62 -241.03)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M337,432.71v28.21a.36.36,0,0,0,.71,0V432.71a.36.36,0,1,0-.71,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M337.38,445a1.82,1.82,0,1,1,0,3.63.36.36,0,0,0,0,.71,2.53,2.53,0,0,0,0-5.06.36.36,0,0,0,0,.72Z",
    transform: "translate(-186.62 -241.03)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M418.89,407.17v5.63a.71.71,0,0,1-1.42,0v-6.34a.71.71,0,0,1,.71-.71h15.37a.71.71,0,0,1,.72.71v6.34a.72.72,0,0,1-1.43,0v-5.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.82,367.89v5.63a.71.71,0,0,1-1.42,0v-6.34a.71.71,0,0,1,.71-.71h15.37a.71.71,0,0,1,.72.71v6.34a.72.72,0,0,1-1.43,0v-5.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M282.57,328v5.62a.71.71,0,0,1-1.42,0v-6.34a.71.71,0,0,1,.71-.71h21.65a.71.71,0,0,1,.71.71v6.34a.71.71,0,1,1-1.42,0V328Z",
    transform: "translate(-186.62 -241.03)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M421.37,401.76v4.7a.71.71,0,1,1-1.42,0v-5a.69.69,0,0,1,.21-.51l4.17-4.17a.71.71,0,0,1,.5-.21h6a.71.71,0,0,1,.71.71v9.17a.71.71,0,0,1-1.42,0V398h-5l-3.76,3.75Z",
    transform: "translate(-186.62 -241.03)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M244.53,358.73v8.45a.72.72,0,0,1-1.43,0V358a.71.71,0,0,1,.71-.71h6a.75.75,0,0,1,.51.21l4.17,4.17a.75.75,0,0,1,.21.51v5a.72.72,0,0,1-1.43,0v-4.7l-3.75-3.75Z",
    transform: "translate(-186.62 -241.03)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M291.33,322.58v4.69a.72.72,0,1,1-1.43,0v-5a.71.71,0,0,1,.21-.5l4.17-4.18a.74.74,0,0,1,.51-.2h6a.71.71,0,0,1,.71.71v9.16a.72.72,0,1,1-1.43,0v-8.45h-5l-3.75,3.76Z",
    transform: "translate(-186.62 -241.03)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M280.27,386.42V412.8a.72.72,0,0,0,1.43,0V386.42a.72.72,0,1,0-1.43,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.56,389.4v71.16a.71.71,0,1,1-1.42,0V388.69a.71.71,0,0,1,.71-.71h6.65a.71.71,0,1,1,0,1.42Z",
    transform: "translate(-186.62 -241.03)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.4,434.4v26.16a.72.72,0,0,1-1.43,0V434.11a.71.71,0,0,1,.21-.5l9.49-9.49a.71.71,0,0,1,.5-.21h16.68a.72.72,0,0,1,0,1.43H214.46l-9.06,9.06Z",
    transform: "translate(-186.62 -241.03)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.48,417.75v6.87a.72.72,0,1,1-1.43,0V417a.71.71,0,0,1,.72-.71h10a.71.71,0,0,1,.71.71v7.58a.71.71,0,1,1-1.42,0v-6.87Z",
    transform: "translate(-186.62 -241.03)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.48,417V398.68a.71.71,0,1,0-1.42,0V417a.71.71,0,1,0,1.42,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M378.3,362.51v19.63a.72.72,0,0,1-1.43,0V361.79a.71.71,0,0,1,.71-.71h31.28a.65.65,0,0,1,.36.1l13.63,7.9a.69.69,0,0,1,.35.61v29.89a.71.71,0,1,1-1.42,0V370.1l-13.11-7.59Z",
    transform: "translate(-186.62 -241.03)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M265.52,345.89v30.22a.71.71,0,1,1-1.42,0V345.62a.74.74,0,0,1,.17-.48l10.28-11.64a.73.73,0,0,1,.54-.24h31.75a.71.71,0,1,1,0,1.42H275.41l-9.89,11.21Z",
    transform: "translate(-186.62 -241.03)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M390.71,323.44H367.93a.71.71,0,1,1,0-1.42h23.49a.71.71,0,0,1,.71.71v39.06a.71.71,0,1,1-1.42,0V323.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M394.9,357v4.79a.71.71,0,1,1-1.42,0v-5.5a.71.71,0,0,1,.71-.72h12.19a.71.71,0,0,1,.71.72v5.5a.71.71,0,1,1-1.42,0V357Z",
    transform: "translate(-186.62 -241.03)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M401,356.29V335.58a.72.72,0,0,0-1.43,0v20.71a.72.72,0,0,0,1.43,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M374.29,317.9v4.79a.72.72,0,0,1-1.43,0v-5.51a.71.71,0,0,1,.72-.71h12.19a.71.71,0,0,1,.71.71v5.51a.71.71,0,0,1-1.42,0V317.9Z",
    transform: "translate(-186.62 -241.03)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M380.38,317.18v-21.5a.71.71,0,0,0-1.42,0v21.5a.71.71,0,1,0,1.42,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M428.45,397.29V386.06a.71.71,0,1,0-1.42,0v11.23a.71.71,0,1,0,1.42,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M298.35,318.11v-7.24a.71.71,0,1,0-1.42,0v7.24a.71.71,0,1,0,1.42,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M247.51,358v-9.4a.71.71,0,0,0-1.42,0V358a.71.71,0,1,0,1.42,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M457.28,427.26H437.16a.71.71,0,1,1,0-1.42h20.3a.76.76,0,0,1,.33.08L477,436.05a.71.71,0,0,1,.38.63v23.88a.71.71,0,0,1-1.42,0V437.11l-18.64-9.85Z",
    transform: "translate(-186.62 -241.03)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M440.35,419.6v6.95a.71.71,0,0,1-1.42,0v-7.66a.71.71,0,0,1,.71-.71h9.58a.73.73,0,0,1,.35.09l5.9,3.39a.72.72,0,0,1,.36.62v4.27a.72.72,0,0,1-1.43,0v-3.86L449,419.6Z",
    transform: "translate(-186.62 -241.03)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M442.47,413.51v5.38a.71.71,0,1,1-1.42,0V412.8a.71.71,0,0,1,.71-.72h5.62a.71.71,0,0,1,.71.72v6.09a.71.71,0,1,1-1.42,0v-5.38Z",
    transform: "translate(-186.62 -241.03)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M445.28,412.8V402.41a.71.71,0,1,0-1.42,0V412.8a.71.71,0,0,0,1.42,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414.6,419.25l-20.73,12.81a.37.37,0,0,1-.5-.12.36.36,0,0,1,.12-.49l20.83-12.86a.3.3,0,0,1,.18-.06h22.66a.36.36,0,0,1,0,.72Z",
    transform: "translate(-186.62 -241.03)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414.6,441.8l-20.73,12.81a.37.37,0,0,1-.5-.11.36.36,0,0,1,.12-.49l20.83-12.87a.37.37,0,0,1,.18-.05h22.66a.36.36,0,1,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414.6,430.62l-20.73,12.81a.37.37,0,0,1-.5-.12.36.36,0,0,1,.12-.49L414.32,430a.29.29,0,0,1,.18,0h22.66a.36.36,0,1,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414.6,453.17l-13.11,8.1a.35.35,0,0,1-.49-.11.36.36,0,0,1,.12-.49l13.2-8.16a.37.37,0,0,1,.18-.05h22.66a.36.36,0,1,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414.6,425l-20.73,12.82a.37.37,0,0,1-.5-.12.36.36,0,0,1,.12-.49l20.83-12.86a.3.3,0,0,1,.18-.06h22.66a.36.36,0,0,1,.36.36.35.35,0,0,1-.36.35Z",
    transform: "translate(-186.62 -241.03)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414.6,447.53l-20.73,12.81a.37.37,0,0,1-.5-.11.36.36,0,0,1,.12-.49l20.83-12.87a.37.37,0,0,1,.18-.05h22.66a.36.36,0,1,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414.6,436.35l-20.73,12.81a.37.37,0,0,1-.5-.12.36.36,0,0,1,.12-.49l20.83-12.86a.3.3,0,0,1,.18-.06h22.66a.36.36,0,0,1,0,.72Z",
    transform: "translate(-186.62 -241.03)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414.6,458.9l-3.87,2.4a.36.36,0,0,1-.49-.12.35.35,0,0,1,.11-.49l4-2.45a.37.37,0,0,1,.18-.05h22.66a.36.36,0,1,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M414.08,412.8V461a.36.36,0,1,0,.71,0V412.8a.36.36,0,1,0-.71,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M457.33,432.08H437.16a.36.36,0,1,1,0-.71h20.26a.33.33,0,0,1,.17,0l19.21,10.34a.37.37,0,0,1,.14.49.35.35,0,0,1-.48.14l-19.13-10.3Z",
    transform: "translate(-186.62 -241.03)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M457.33,441.27H437.16a.36.36,0,0,1,0-.72h20.26a.34.34,0,0,1,.17.05l19.21,10.34a.36.36,0,0,1,.14.48.35.35,0,0,1-.48.15l-19.13-10.3Z",
    transform: "translate(-186.62 -241.03)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M457.33,456H437.16a.36.36,0,1,1,0-.72h20.26a.34.34,0,0,1,.17.05l10,5.38a.36.36,0,0,1-.34.63L457.33,456Z",
    transform: "translate(-186.62 -241.03)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M457.33,436.63H437.16a.36.36,0,1,1,0-.71h20.26a.33.33,0,0,1,.17,0L476.8,446.3a.37.37,0,0,1,.14.49.36.36,0,0,1-.48.14l-19.13-10.3Z",
    transform: "translate(-186.62 -241.03)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M457.33,451.33H437.16a.36.36,0,1,1,0-.71h20.26a.33.33,0,0,1,.17,0L476.8,461a.37.37,0,0,1,.14.49.36.36,0,0,1-.48.14l-19.13-10.3Z",
    transform: "translate(-186.62 -241.03)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M457.33,446.16H437.16a.36.36,0,0,1,0-.72h20.26a.34.34,0,0,1,.17.05l19.21,10.34a.36.36,0,0,1,.14.48.35.35,0,0,1-.48.15l-19.13-10.3Z",
    transform: "translate(-186.62 -241.03)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M457,426.55v34.37a.36.36,0,0,0,.72,0V426.55a.36.36,0,0,0-.72,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.81,368.31H377.58a.36.36,0,0,1,0-.72h31.33a.35.35,0,0,1,.18.05l13.58,8a.36.36,0,1,1-.36.62l-13.5-8Z",
    transform: "translate(-186.62 -241.03)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.81,389.66H380a.36.36,0,0,1,0-.71h29a.35.35,0,0,1,.18.05l13.58,8a.35.35,0,1,1-.36.61l-13.5-8Z",
    transform: "translate(-186.62 -241.03)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.81,379H377.58a.36.36,0,0,1,0-.71h31.33a.35.35,0,0,1,.18.05l13.58,8a.35.35,0,1,1-.36.61l-13.5-8Z",
    transform: "translate(-186.62 -241.03)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.81,400.35H380a.36.36,0,0,1,0-.71h29a.35.35,0,0,1,.18.05l11,6.48a.35.35,0,0,1,.13.48.36.36,0,0,1-.49.13l-10.89-6.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.81,411.26H380a.36.36,0,0,1,0-.71h29a.35.35,0,0,1,.18.05l4.46,2.63a.35.35,0,1,1-.36.61l-4.38-2.58Z",
    transform: "translate(-186.62 -241.03)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.81,373.83H377.58a.36.36,0,0,1,0-.71h31.33a.27.27,0,0,1,.18.05l13.58,8a.35.35,0,0,1,.13.48.36.36,0,0,1-.49.13l-13.5-8Z",
    transform: "translate(-186.62 -241.03)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.81,395.19H380a.36.36,0,0,1,0-.72h29a.35.35,0,0,1,.18,0l11.81,7a.35.35,0,1,1-.36.61l-11.73-6.92Z",
    transform: "translate(-186.62 -241.03)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.81,384.52H379.9a.36.36,0,0,1,0-.72h29a.35.35,0,0,1,.18.05l13.58,8a.36.36,0,0,1-.36.62l-13.5-8Z",
    transform: "translate(-186.62 -241.03)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.81,405.87H380a.36.36,0,0,1,0-.71h29a.35.35,0,0,1,.18,0l9.29,5.49a.35.35,0,0,1-.36.61l-9.21-5.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.45,361.79v54.45a.36.36,0,0,0,.72,0V361.79a.36.36,0,0,0-.72,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M393.75,416.78h15.16a.36.36,0,1,0,0-.71H393.75a.36.36,0,1,0,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M367.93,329.23h23.4a.36.36,0,1,0,0-.71h-23.4a.36.36,0,1,0,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.79,353.11h19.54a.36.36,0,1,0,0-.71H371.79a.36.36,0,1,0,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.79,341.18h19.54a.36.36,0,1,0,0-.71H371.79a.36.36,0,1,0,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.79,365.06h5.79a.35.35,0,0,0,.36-.35.36.36,0,0,0-.36-.36h-5.79a.36.36,0,0,0-.36.36.35.35,0,0,0,.36.35Z",
    transform: "translate(-186.62 -241.03)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M367.93,335.35h23.4a.36.36,0,1,0,0-.71h-23.4a.36.36,0,1,0,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.79,359.23h19.54a.36.36,0,1,0,0-.71H371.79a.36.36,0,1,0,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.79,347.31h19.54a.36.36,0,0,0,0-.72H371.79a.36.36,0,0,0,0,.72Z",
    transform: "translate(-186.62 -241.03)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.79,371.19h5.79a.36.36,0,1,0,0-.72h-5.79a.36.36,0,1,0,0,.72Z",
    transform: "translate(-186.62 -241.03)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.79,377.1h5.79a.36.36,0,1,0,0-.71h-5.79a.36.36,0,1,0,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.6,339.8l-10.53,11.65a.36.36,0,0,1-.5,0,.35.35,0,0,1,0-.5l10.64-11.77a.37.37,0,0,1,.27-.11H303a.36.36,0,0,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.6,360.76l-10.53,11.65a.35.35,0,0,1-.5,0,.36.36,0,0,1,0-.51l10.64-11.76a.34.34,0,0,1,.27-.12H303a.36.36,0,0,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.6,381.59l-.87,1a.36.36,0,0,1-.5,0,.35.35,0,0,1,0-.5l1-1.08a.34.34,0,0,1,.27-.12H303a.36.36,0,0,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.6,350.35,265.07,362a.36.36,0,0,1-.5,0,.35.35,0,0,1,0-.5l10.64-11.77a.37.37,0,0,1,.27-.11H303a.36.36,0,0,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.6,371.31l-6.79,7.52a.36.36,0,0,1-.5,0,.35.35,0,0,1,0-.5l6.9-7.63a.34.34,0,0,1,.27-.12H303a.36.36,0,0,1,.35.36.35.35,0,0,1-.35.35Z",
    transform: "translate(-186.62 -241.03)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.75,391.43H281a.36.36,0,1,0,0,.71h13.76a.36.36,0,0,0,0-.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.75,406.09H281a.35.35,0,0,0-.36.35.36.36,0,0,0,.36.36h13.76a.36.36,0,0,0,.35-.36.35.35,0,0,0-.35-.35Z",
    transform: "translate(-186.62 -241.03)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.6,345.24l-10.53,11.64a.35.35,0,0,1-.53-.47l10.64-11.77a.38.38,0,0,1,.27-.12H303a.36.36,0,0,1,0,.72Z",
    transform: "translate(-186.62 -241.03)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.6,366.2,265.84,377a.35.35,0,0,1-.5,0,.36.36,0,0,1,0-.51l9.87-10.91a.34.34,0,0,1,.27-.12H303a.36.36,0,0,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.75,386.32H281.08a.36.36,0,0,0,0,.71h13.67a.36.36,0,0,0,0-.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.75,401.33H281a.36.36,0,1,0,0,.71h13.76a.36.36,0,0,0,0-.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.6,355.79l-10.53,11.65a.36.36,0,0,1-.5,0,.35.35,0,0,1,0-.5l10.64-11.77a.37.37,0,0,1,.27-.11H303a.36.36,0,0,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.6,376.75l-3.63,4a.34.34,0,0,1-.5,0,.35.35,0,0,1,0-.5l3.74-4.13a.34.34,0,0,1,.27-.12H303a.36.36,0,0,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.75,396.87H281a.36.36,0,1,0,0,.71h13.76a.36.36,0,0,0,0-.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.75,410.8H281a.36.36,0,0,0,0,.72h13.76a.36.36,0,0,0,0-.72Z",
    transform: "translate(-186.62 -241.03)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275,334V383a.36.36,0,1,0,.71,0V334a.36.36,0,1,0-.71,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,380H237.5a.36.36,0,0,1,0-.71h22.67a.31.31,0,0,1,.19.06l20.91,13.15a.36.36,0,1,1-.37.61L260.07,380Z",
    transform: "translate(-186.62 -241.03)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,420.39H237.5a.36.36,0,0,1,0-.71h22.67a.38.38,0,0,1,.19.05l20.91,13.16a.36.36,0,0,1,.12.49.35.35,0,0,1-.49.11l-20.83-13.1Z",
    transform: "translate(-186.62 -241.03)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,391.58H237.5a.36.36,0,0,1,0-.71h22.67a.31.31,0,0,1,.19.06l20.91,13.15a.36.36,0,1,1-.37.61l-20.83-13.11Z",
    transform: "translate(-186.62 -241.03)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,432H237.5a.36.36,0,0,1,0-.71h22.67a.38.38,0,0,1,.19.05l20.91,13.16a.36.36,0,0,1,.12.49.35.35,0,0,1-.49.11L260.07,432Z",
    transform: "translate(-186.62 -241.03)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,408.74H237.5a.36.36,0,0,1,0-.72h22.67a.31.31,0,0,1,.19.06l20.91,13.15a.36.36,0,1,1-.37.61l-20.83-13.1Z",
    transform: "translate(-186.62 -241.03)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,449.1H237.5a.36.36,0,0,1,0-.71h22.67a.41.41,0,0,1,.19.05l19.92,12.17a.35.35,0,0,1,.12.49.36.36,0,0,1-.49.12L260.07,449.1Z",
    transform: "translate(-186.62 -241.03)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,386H237.5a.36.36,0,0,1,0-.71h22.67a.3.3,0,0,1,.19.05l20.91,13.16a.36.36,0,0,1,.12.49.37.37,0,0,1-.49.11L260.07,386Z",
    transform: "translate(-186.62 -241.03)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,426.33H237.5a.36.36,0,0,1,0-.72h22.67a.31.31,0,0,1,.19.06l20.91,13.15a.36.36,0,1,1-.37.61l-20.83-13.1Z",
    transform: "translate(-186.62 -241.03)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,403.11H237.5a.36.36,0,0,1,0-.71h22.67a.38.38,0,0,1,.19.05l20.91,13.16a.36.36,0,0,1,.12.49.35.35,0,0,1-.49.11l-20.83-13.1Z",
    transform: "translate(-186.62 -241.03)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,443.48H237.5a.36.36,0,0,1,0-.72h22.67a.31.31,0,0,1,.19.06L281.27,456a.36.36,0,0,1,.12.49.37.37,0,0,1-.49.11l-20.83-13.1Z",
    transform: "translate(-186.62 -241.03)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,397.52H237.5a.36.36,0,0,1,0-.71h22.67a.3.3,0,0,1,.19.05L281.27,410a.36.36,0,0,1,.12.49.37.37,0,0,1-.49.11l-20.83-13.1Z",
    transform: "translate(-186.62 -241.03)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,437.89H237.5a.36.36,0,0,1,0-.72h22.67a.31.31,0,0,1,.19.06l20.91,13.15a.36.36,0,0,1-.37.61l-20.83-13.1Z",
    transform: "translate(-186.62 -241.03)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,414.67H237.5a.36.36,0,0,1,0-.71h22.67a.38.38,0,0,1,.19.05l20.91,13.16a.35.35,0,1,1-.37.6l-20.83-13.1Z",
    transform: "translate(-186.62 -241.03)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.07,455H237.5a.36.36,0,0,1,0-.72h22.67a.31.31,0,0,1,.19.06l9.92,6.24a.36.36,0,0,1,.11.49.37.37,0,0,1-.49.11L260.07,455Z",
    transform: "translate(-186.62 -241.03)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M259.63,373.52v87.4a.36.36,0,0,0,.71,0v-87.4a.36.36,0,1,0-.71,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.58,430l-9.65,9.47a.36.36,0,0,1-.5,0,.34.34,0,0,1,0-.5l9.74-9.57a.36.36,0,0,1,.25-.11h16.42a.36.36,0,0,1,0,.72Z",
    transform: "translate(-186.62 -241.03)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.58,449.1l-9.65,9.47a.36.36,0,0,1-.5,0,.34.34,0,0,1,0-.5l9.74-9.57a.35.35,0,0,1,.25-.1h16.42a.35.35,0,0,1,.35.35.36.36,0,0,1-.35.36Z",
    transform: "translate(-186.62 -241.03)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.58,439.53,204.93,449a.36.36,0,0,1-.5,0,.34.34,0,0,1,0-.5l9.74-9.57a.36.36,0,0,1,.25-.11h16.42a.36.36,0,0,1,0,.72Z",
    transform: "translate(-186.62 -241.03)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.57,458.67l-2.79,2.62a.35.35,0,0,1-.5,0,.36.36,0,0,1,0-.51l2.9-2.72a.34.34,0,0,1,.24-.09h16.42a.36.36,0,0,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.58,434.74l-9.65,9.47a.35.35,0,1,1-.49-.51l9.74-9.57a.39.39,0,0,1,.25-.1h16.42a.36.36,0,0,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.58,453.88,207,461.29a.37.37,0,0,1-.51,0,.36.36,0,0,1,0-.5l7.64-7.51a.39.39,0,0,1,.25-.1h16.42a.36.36,0,0,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.58,444.31l-9.65,9.47a.35.35,0,1,1-.49-.51l9.74-9.57a.39.39,0,0,1,.25-.1h16.42a.36.36,0,0,1,0,.71Z",
    transform: "translate(-186.62 -241.03)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M427.74,375.38a11.11,11.11,0,0,1,20.32-3.69,8.34,8.34,0,0,1,11.77,7.58,7.77,7.77,0,0,1-.06,1,5,5,0,0,1,4.09,3.43H464a3.21,3.21,0,0,1,2.35,5.4.72.72,0,0,1-1,0,.71.71,0,0,1,0-1,1.79,1.79,0,0,0-1.31-3,2,2,0,0,0-.49.07.68.68,0,0,1-.57-.08.72.72,0,0,1-.32-.49,3.56,3.56,0,0,0-3.5-3H459a.72.72,0,0,1-.58-.26.74.74,0,0,1-.15-.61,6.67,6.67,0,0,0,.16-1.49,6.9,6.9,0,0,0-6.89-6.9,6.82,6.82,0,0,0-3.37.88.71.71,0,0,1-.55.07.75.75,0,0,1-.43-.35,9.68,9.68,0,0,0-18.1,3.12.7.7,0,0,1-.61.6,6.05,6.05,0,0,0-5.15,5.6.72.72,0,0,1-.76.67.71.71,0,0,1-.66-.76,7.46,7.46,0,0,1,5.86-6.82Z",
    transform: "translate(-186.62 -241.03)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M465.83,387.87H446.22a.71.71,0,0,0,0,1.42h19.61a.71.71,0,0,0,0-1.42Z",
    transform: "translate(-186.62 -241.03)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.33,347.77a11.11,11.11,0,0,1,20.33,3.68,7.48,7.48,0,0,1,5.86,6.83.71.71,0,0,1-.67.75.7.7,0,0,1-.75-.66,6.05,6.05,0,0,0-5.16-5.6.71.71,0,0,1-.6-.6,9.69,9.69,0,0,0-18.11-3.12.71.71,0,0,1-.42.34.7.7,0,0,1-.55-.06,6.9,6.9,0,0,0-10.27,6,7.31,7.31,0,0,0,.16,1.49.71.71,0,0,1-.15.61.69.69,0,0,1-.57.25h-.15a3.55,3.55,0,0,0-3.5,3,.72.72,0,0,1-.32.49.74.74,0,0,1-.58.08,2,2,0,0,0-.49-.07,1.78,1.78,0,0,0-1.78,1.79,1.75,1.75,0,0,0,.48,1.21.72.72,0,0,1,0,1,.71.71,0,0,1-1,0,3.21,3.21,0,0,1,2.35-5.39h.15a5,5,0,0,1,4.08-3.43,7.77,7.77,0,0,1-.06-1,8.32,8.32,0,0,1,11.77-7.58Z",
    transform: "translate(-186.62 -241.03)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.56,365.37h20.49a.71.71,0,1,0,0-1.42H200.56a.71.71,0,0,0,0,1.42Z",
    transform: "translate(-186.62 -241.03)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M392.71,316.44a9,9,0,0,1,16.43-3,6.8,6.8,0,0,1,9.5,6.24q0,.33,0,.66a4.11,4.11,0,0,1,3.21,2.72h0a2.7,2.7,0,0,1,2,4.55.71.71,0,0,1-1,0,.72.72,0,0,1,0-1,1.29,1.29,0,0,0-.94-2.16,1.34,1.34,0,0,0-.35,0,.69.69,0,0,1-.58-.08.72.72,0,0,1-.32-.49,2.7,2.7,0,0,0-2.66-2.26h-.11a.72.72,0,0,1-.58-.26.71.71,0,0,1-.15-.61,5.5,5.5,0,0,0,.13-1.16,5.37,5.37,0,0,0-5.38-5.37,5.27,5.27,0,0,0-2.62.68.71.71,0,0,1-.55.06.7.7,0,0,1-.43-.34A7.6,7.6,0,0,0,394,317.15a.72.72,0,0,1-.6.6,4.69,4.69,0,0,0-4,4.34.71.71,0,0,1-.75.67A.72.72,0,0,1,388,322a6.12,6.12,0,0,1,4.71-5.56Z",
    transform: "translate(-186.62 -241.03)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M423.3,326.4h-17a.72.72,0,0,0,0,1.43h17a.72.72,0,0,0,0-1.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299.47,280.73a9,9,0,0,1,16.43,3,6.12,6.12,0,0,1,4.71,5.57.7.7,0,0,1-.66.75.71.71,0,0,1-.76-.66,4.7,4.7,0,0,0-4-4.35.69.69,0,0,1-.6-.59A7.61,7.61,0,0,0,300.37,282a.69.69,0,0,1-.43.35.72.72,0,0,1-.54-.06,5.37,5.37,0,0,0-8,4.68,5.66,5.66,0,0,0,.12,1.17.71.71,0,0,1-.15.61.69.69,0,0,1-.57.25h-.12a2.7,2.7,0,0,0-2.65,2.25.71.71,0,0,1-.33.49.68.68,0,0,1-.57.08,1.37,1.37,0,0,0-.36,0,1.28,1.28,0,0,0-1.28,1.28,1.27,1.27,0,0,0,.35.88.71.71,0,0,1-1,1,2.72,2.72,0,0,1,2-4.56h0a4.11,4.11,0,0,1,3.21-2.72c0-.22,0-.43,0-.66a6.8,6.8,0,0,1,9.5-6.24Z",
    transform: "translate(-186.62 -241.03)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M285.53,295.13h19.29a.71.71,0,1,0,0-1.42H285.53a.71.71,0,1,0,0,1.42Z",
    transform: "translate(-186.62 -241.03)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M307.1,295.13h5.76a.71.71,0,1,0,0-1.42H307.1a.71.71,0,1,0,0,1.42Z",
    transform: "translate(-186.62 -241.03)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M403.85,326.4h-6.09a.72.72,0,0,0,0,1.43h6.09a.72.72,0,0,0,0-1.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M444,387.87H436.6a.71.71,0,1,0,0,1.42H444a.71.71,0,0,0,0-1.42Z",
    transform: "translate(-186.62 -241.03)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.39,365.37h8a.71.71,0,1,0,0-1.42h-8a.71.71,0,0,0,0,1.42Z",
    transform: "translate(-186.62 -241.03)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.72,369.36h19.13a.71.71,0,1,0,0-1.42H206.72a.71.71,0,1,0,0,1.42Z",
    transform: "translate(-186.62 -241.03)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.34,298.07h13.53a.71.71,0,1,0,0-1.42H294.34a.71.71,0,0,0,0,1.42Z",
    transform: "translate(-186.62 -241.03)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M405.15,332.07h13.53a.72.72,0,0,0,0-1.43H405.15a.72.72,0,0,0,0,1.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M442.19,393.39h19.29a.72.72,0,0,0,0-1.43H442.19a.72.72,0,0,0,0,1.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M647,281a6.34,6.34,0,0,1,9.42,3.77.31.31,0,0,1-.22.39.32.32,0,0,1-.39-.23,5.71,5.71,0,0,0-8.76-3.21.33.33,0,0,1-.26,0,.31.31,0,0,1-.2-.17,5.72,5.72,0,0,0-9.19-1.59.33.33,0,0,1-.45,0,.31.31,0,0,1,0-.45A6.34,6.34,0,0,1,647,281Z",
    transform: "translate(-186.62 -241.03)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M710.66,315.46A6.36,6.36,0,0,1,720.71,314a.31.31,0,0,1,0,.45.32.32,0,0,1-.45,0,5.7,5.7,0,0,0-9.19,1.59.3.3,0,0,1-.46.12,5.72,5.72,0,0,0-8.76,3.22.32.32,0,1,1-.61-.17,6.34,6.34,0,0,1,9.42-3.77Z",
    transform: "translate(-186.62 -241.03)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M504.16,314.93a6.36,6.36,0,0,1,9.68-3.06.32.32,0,0,1,.08.45.33.33,0,0,1-.45.07,5.71,5.71,0,0,0-8.81,3.06.3.3,0,0,1-.17.21.36.36,0,0,1-.27,0,5.72,5.72,0,0,0-8.11,4.6.32.32,0,1,1-.63-.06,6.35,6.35,0,0,1,8.68-5.26Z",
    transform: "translate(-186.62 -241.03)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M477.36,390.16V461a.64.64,0,1,1-1.27,0V389.52a.63.63,0,0,1,.64-.63h5.11a.59.59,0,0,1,.29.07l33.43,17.37H545.1a.64.64,0,0,1,.64.63v29.38a.64.64,0,0,1-.64.64.64.64,0,0,1-.63-.64V407.6H515.41a.73.73,0,0,1-.29-.07l-33.44-17.37Z",
    transform: "translate(-186.62 -241.03)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M657.17,317v30.3a.64.64,0,0,1-.63.64.64.64,0,0,1-.64-.64V316.39a.64.64,0,0,1,.64-.64h16.27a.64.64,0,0,1,.64.64v18.76a.64.64,0,0,1-.64.64.64.64,0,0,1-.63-.64V317Z",
    transform: "translate(-186.62 -241.03)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M678.38,317v18.12a.64.64,0,0,1-.64.64.64.64,0,0,1-.63-.64V316.39a.64.64,0,0,1,.63-.64H694a.64.64,0,0,1,.63.64v30.94a.64.64,0,1,1-1.27,0V317Z",
    transform: "translate(-186.62 -241.03)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M649.76,425.81a.64.64,0,0,1,.61-.45h16.46a.64.64,0,0,1,.63.64v35a.64.64,0,0,1-.63.64H650.37a.64.64,0,0,1-.64-.64V425.81Zm1.25.83v33.68h15.18V426.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M683.09,425.94a.65.65,0,0,1,.64-.58h16.45a.64.64,0,0,1,.64.64v35a.64.64,0,0,1-.64.64H683.73a.64.64,0,0,1-.64-.64v-35Zm1.27.7v33.68h15.19V426.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M678.71,460.32V412.44a.64.64,0,1,1,1.27,0V461a.64.64,0,0,1-.63.64h-8.14a.64.64,0,0,1-.64-.64V412.44a.64.64,0,0,1,.64-.64.64.64,0,0,1,.63.64v47.88Z",
    transform: "translate(-186.62 -241.03)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M683.73,460.32h-16.9a.64.64,0,1,0,0,1.28h16.9a.64.64,0,0,0,0-1.28Z",
    transform: "translate(-186.62 -241.03)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M655,348v78a.64.64,0,0,1-.64.64.64.64,0,0,1-.63-.64V347.33a.63.63,0,0,1,.63-.63h16.85a.63.63,0,0,1,.63.63v65.11a.63.63,0,0,1-.63.63.64.64,0,0,1-.64-.63V348Z",
    transform: "translate(-186.62 -241.03)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M680,348v64.47a.64.64,0,0,1-1.27,0V347.33a.63.63,0,0,1,.64-.63h16.84a.64.64,0,0,1,.64.63V426a.64.64,0,0,1-.64.64.64.64,0,0,1-.63-.64V348Z",
    transform: "translate(-186.62 -241.03)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.84,335.79v11.54a.64.64,0,0,1-.63.64.64.64,0,0,1-.64-.64V335.15a.64.64,0,0,1,.64-.63h8.14a.63.63,0,0,1,.63.63v12.18a.64.64,0,1,1-1.27,0V335.79Z",
    transform: "translate(-186.62 -241.03)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M659.82,307.06v9.33a.64.64,0,0,1-.63.64.64.64,0,0,1-.64-.64v-10a.64.64,0,0,1,.64-.64h32.18a.64.64,0,0,1,.63.64v10a.64.64,0,0,1-.63.64.64.64,0,0,1-.64-.64v-9.33Z",
    transform: "translate(-186.62 -241.03)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M662.46,302.81v3.61a.64.64,0,0,1-1.28,0v-4.24a.64.64,0,0,1,.64-.64h26.91a.63.63,0,0,1,.64.64v4.24a.64.64,0,1,1-1.27,0v-3.61Z",
    transform: "translate(-186.62 -241.03)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.62,292.49v9.69a.63.63,0,0,1-.63.63.64.64,0,0,1-.64-.63V291.86a.64.64,0,0,1,.64-.64h18.58a.64.64,0,0,1,.63.64v10.32a.63.63,0,0,1-.63.63.64.64,0,0,1-.64-.63v-9.69Z",
    transform: "translate(-186.62 -241.03)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M668.23,291.64a.63.63,0,0,0,.08.58.62.62,0,0,0,.52.27h12.9a.64.64,0,0,0,.52-.27.6.6,0,0,0,.07-.58c-2.47-6.75-3.36-15.07-2.37-25.28a.64.64,0,0,0-.16-.49.67.67,0,0,0-.48-.21h-8.07a.64.64,0,0,0-.47.21.64.64,0,0,0-.16.49c1,10.21.09,18.53-2.38,25.28Zm10.39-24.7h-6.68c.86,9.69,0,17.7-2.21,24.28h11.1c-2.25-6.59-3.08-14.59-2.21-24.28Z",
    transform: "translate(-186.62 -241.03)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.88,263.58v2.72a.64.64,0,1,1-1.28,0v-3.36a.64.64,0,0,1,.64-.63h8.11a.63.63,0,0,1,.63.63v3.31a.64.64,0,1,1-1.27,0v-2.67Z",
    transform: "translate(-186.62 -241.03)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.38,262.69a.67.67,0,0,0,0,.6.64.64,0,0,0,.53.29h6.66a.65.65,0,0,0,.59-.89,11.54,11.54,0,0,1-1-4.32.63.63,0,0,0-.63-.61H673a.63.63,0,0,0-.64.61,11.74,11.74,0,0,1-.94,4.32ZM677,259h-3.46a13.15,13.15,0,0,1-.67,3.28h4.8A13.15,13.15,0,0,1,677,259Z",
    transform: "translate(-186.62 -241.03)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M675.93,258.39V241.66a.64.64,0,0,0-.64-.63.63.63,0,0,0-.63.63v16.73a.64.64,0,0,0,.63.64.64.64,0,0,0,.64-.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,352.46h16.85a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32H654.36a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,351.82H679.23a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32h16.85a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,385h16.85a.32.32,0,1,0,0-.63H654.36a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,384.36H679.23a.32.32,0,1,0,0,.63h16.85a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,445.77h4.38a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32h-4.38a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M683.61,445.13h-4.38a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32h4.38a.32.32,0,0,0,.32-.32.32.32,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,368.75h16.85a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32H654.36a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M656.54,333h16.27a.32.32,0,0,0,.32-.32.32.32,0,0,0-.32-.32H656.54a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,368.11H679.23a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32h16.85a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,429.52h4.38a.32.32,0,1,0,0-.63h-4.38a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M683.61,428.89h-4.38a.32.32,0,1,0,0,.63h4.38a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,401.28h16.85a.32.32,0,1,0,0-.63H654.36a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,400.65H679.23a.32.32,0,1,0,0,.63h16.85a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,356.7h16.85a.32.32,0,1,0,0-.63H654.36a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M656.54,321h16.27a.32.32,0,0,0,.32-.32.32.32,0,0,0-.32-.32H656.54a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,356.07H679.23a.32.32,0,1,0,0,.63h16.85a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,417.48h16.85a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32H654.36a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,416.84H679.23a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32h16.85a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,389.24h16.85a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H654.36a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,388.6H679.23a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32h16.85a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,450h4.38a.32.32,0,1,0,0-.63h-4.38a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M683.61,449.38h-4.38a.32.32,0,1,0,0,.63h4.38a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,373h16.85a.32.32,0,1,0,0-.63H654.36a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M656.54,338.06h14.67a.32.32,0,1,0,0-.63H656.54a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,372.36H679.23a.32.32,0,1,0,0,.63h16.85a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,433.77h4.38a.32.32,0,1,0,0-.64h-4.38a.32.32,0,1,0,0,.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M683.61,433.13h-4.38a.32.32,0,1,0,0,.64h4.38a.32.32,0,1,0,0-.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,405.53h16.85a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H654.36a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,404.89H679.23a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32h16.85a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,360.52h16.85a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32H654.36a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M656.54,324.77h16.27a.32.32,0,0,0,0-.64H656.54a.32.32,0,0,0,0,.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,359.88H679.23a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32h16.85a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,421.3h16.85a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H654.36a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,420.66H679.23a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32h16.85a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,393.05h16.85a.32.32,0,1,0,0-.63H654.36a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,392.42H679.23a.32.32,0,1,0,0,.63h16.85a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,453.83h4.38a.32.32,0,1,0,0-.64h-4.38a.32.32,0,1,0,0,.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M683.61,453.19h-4.38a.32.32,0,1,0,0,.64h4.38a.32.32,0,1,0,0-.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,376.81h16.85a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32H654.36a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M656.54,342.71h14.67a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H656.54a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,376.17H679.23a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32h16.85a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,437.58h4.38a.32.32,0,1,0,0-.63h-4.38a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M683.61,437h-4.38a.32.32,0,1,0,0,.63h4.38a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,409.34h16.85a.32.32,0,1,0,0-.63H654.36a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,408.71H679.23a.32.32,0,1,0,0,.63h16.85a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,364.76h16.85a.32.32,0,1,0,0-.63H654.36a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M656.54,329h16.27a.32.32,0,1,0,0-.63H656.54a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M694.05,332.36H677.77a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32h16.28a.32.32,0,0,0,.31-.32.31.31,0,0,0-.31-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M694.05,320.31H677.77a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32h16.28a.31.31,0,0,0,.31-.32.32.32,0,0,0-.31-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M694.05,337.43H679.38a.32.32,0,1,0,0,.63h14.67a.32.32,0,0,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M694.05,324.13H677.77a.32.32,0,0,0,0,.64h16.28a.32.32,0,0,0,0-.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M694.05,342.07H679.38a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32h14.67a.32.32,0,0,0,.31-.32.31.31,0,0,0-.31-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M694.05,328.38H677.77a.32.32,0,1,0,0,.63h16.28a.32.32,0,0,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,364.13H679.23a.32.32,0,1,0,0,.63h16.85a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,425.54h16.85a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32H654.36a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,424.9H679.23a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32h16.85a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,397.3h16.85a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H654.36a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,396.66H679.23a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32h16.85a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,458.07h4.38a.32.32,0,1,0,0-.63h-4.38a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M683.61,457.44h-4.38a.32.32,0,1,0,0,.63h4.38a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,381.05h16.85a.32.32,0,1,0,0-.63H654.36a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,380.42H679.23a.32.32,0,1,0,0,.63h16.85a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,441.83h4.38a.32.32,0,1,0,0-.64h-4.38a.32.32,0,1,0,0,.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,431H650.37a.32.32,0,1,0,0,.63h16.46a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.05,431H683.59a.32.32,0,1,0,0,.63h16.46a.32.32,0,0,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,439.14H650.37a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32h16.46a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.05,439.14H683.59a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32h16.46a.32.32,0,0,0,.31-.32.31.31,0,0,0-.31-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,447.32H650.37a.32.32,0,1,0,0,.64h16.46a.32.32,0,1,0,0-.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.05,447.32H683.59a.32.32,0,1,0,0,.64h16.46a.32.32,0,0,0,0-.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,435.13H650.37a.32.32,0,1,0,0,.64h16.46a.32.32,0,1,0,0-.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.05,435.13H683.59a.32.32,0,1,0,0,.64h16.46a.32.32,0,0,0,0-.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,443.25H650.37a.32.32,0,1,0,0,.63h16.46a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.05,443.25H683.59a.32.32,0,1,0,0,.63h16.46a.32.32,0,0,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,451.43H650.37a.32.32,0,1,0,0,.63h16.46a.32.32,0,1,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.05,451.43H683.59a.32.32,0,1,0,0,.63h16.46a.32.32,0,0,0,0-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.83,455.44H650.37a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32h16.46a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.05,455.44H683.59a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32h16.46a.31.31,0,0,0,.31-.32.32.32,0,0,0-.31-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M683.61,441.19h-4.38a.32.32,0,1,0,0,.64h4.38a.32.32,0,1,0,0-.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.36,413.59h16.85a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H654.36a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.08,413H679.23a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32h16.85a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,350.17h8a.32.32,0,0,0,.32-.32.32.32,0,0,0-.32-.32h-8a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,375h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,403.31h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,435.59h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,362.66h8a.32.32,0,1,0,0-.64h-8a.32.32,0,0,0,0,.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,391h8a.32.32,0,1,0,0-.64h-8a.32.32,0,1,0,0,.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,423.29h8a.32.32,0,1,0,0-.64h-8a.32.32,0,1,0,0,.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,387.31h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,419.59h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,415.66h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,447.94h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,456.57h8a.32.32,0,1,0,0-.64h-8a.32.32,0,1,0,0,.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,345.25h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,371h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,399.31h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,431.59h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,358.67h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,382.81h8a.32.32,0,0,0,.32-.32.32.32,0,0,0-.32-.32h-8a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,411.16h8a.32.32,0,0,0,.32-.32.32.32,0,0,0-.32-.32h-8a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,443.44h8a.32.32,0,0,0,.32-.32.32.32,0,0,0-.32-.32h-8a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,452.06h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,340.3h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,366.93h8a.32.32,0,1,0,0-.64h-8a.32.32,0,1,0,0,.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,395.28h8a.32.32,0,0,0,.32-.32.32.32,0,0,0-.32-.32h-8a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,427.56h8a.32.32,0,0,0,.32-.32.32.32,0,0,0-.32-.32h-8a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,354.84h8a.32.32,0,0,0,.32-.32.32.32,0,0,0-.32-.32h-8a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,379h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,407.32h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M671.21,439.6h8a.32.32,0,1,0,0-.63h-8a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M662,310.17v6.22a.33.33,0,0,1-.32.32.32.32,0,0,1-.32-.32v-6.53a.32.32,0,0,1,.32-.32h3a.32.32,0,0,1,.32.32v6.53a.32.32,0,1,1-.63,0v-6.22Z",
    transform: "translate(-186.62 -241.03)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M664.1,304.08v2.34a.32.32,0,0,1-.32.32.32.32,0,0,1-.32-.32v-2.66a.31.31,0,0,1,.32-.31h3a.31.31,0,0,1,.32.31v2.66a.32.32,0,0,1-.32.32.32.32,0,0,1-.32-.32v-2.34Z",
    transform: "translate(-186.62 -241.03)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M669.1,304.08v2.34a.32.32,0,1,1-.63,0v-2.66a.31.31,0,0,1,.31-.31h3a.31.31,0,0,1,.32.31v2.66a.32.32,0,0,1-.32.32.32.32,0,0,1-.32-.32v-2.34Z",
    transform: "translate(-186.62 -241.03)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M674.09,304.08v2.34a.32.32,0,1,1-.63,0v-2.66a.31.31,0,0,1,.32-.31h3a.31.31,0,0,1,.32.31v2.66a.32.32,0,0,1-.32.32.32.32,0,0,1-.32-.32v-2.34Z",
    transform: "translate(-186.62 -241.03)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M679.12,304.08v2.34a.32.32,0,1,1-.64,0v-2.66a.31.31,0,0,1,.32-.31h3a.31.31,0,0,1,.32.31v2.66a.32.32,0,1,1-.63,0v-2.34Z",
    transform: "translate(-186.62 -241.03)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M684.11,304.08v2.34a.32.32,0,0,1-.32.32.32.32,0,0,1-.32-.32v-2.66a.32.32,0,0,1,.32-.31h3a.31.31,0,0,1,.31.31v2.66a.32.32,0,1,1-.63,0v-2.34Z",
    transform: "translate(-186.62 -241.03)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M668.53,310.17v6.22a.33.33,0,0,1-.32.32.32.32,0,0,1-.32-.32v-6.53a.32.32,0,0,1,.32-.32h3a.32.32,0,0,1,.32.32v6.53a.32.32,0,1,1-.63,0v-6.22Z",
    transform: "translate(-186.62 -241.03)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M669.14,295.56v6.22a.32.32,0,1,1-.63,0v-6.53a.32.32,0,0,1,.32-.32h3a.32.32,0,0,1,.32.32v6.53a.32.32,0,0,1-.32.32.33.33,0,0,1-.32-.32v-6.22Z",
    transform: "translate(-186.62 -241.03)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M674.1,295.56v6.22a.32.32,0,1,1-.63,0v-6.53a.31.31,0,0,1,.31-.32h3a.32.32,0,0,1,.32.32v6.53a.33.33,0,0,1-.32.32.32.32,0,0,1-.32-.32v-6.22Z",
    transform: "translate(-186.62 -241.03)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M679.06,295.56v6.22a.32.32,0,0,1-.32.32.33.33,0,0,1-.32-.32v-6.53a.32.32,0,0,1,.32-.32h3a.31.31,0,0,1,.31.32v6.53a.32.32,0,1,1-.63,0v-6.22Z",
    transform: "translate(-186.62 -241.03)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M679.72,310.17v6.22a.33.33,0,0,1-.32.32.32.32,0,0,1-.32-.32v-6.53a.32.32,0,0,1,.32-.32h3a.32.32,0,0,1,.32.32v6.53a.32.32,0,1,1-.63,0v-6.22Z",
    transform: "translate(-186.62 -241.03)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M686.3,310.17v6.22a.33.33,0,0,1-.32.32.32.32,0,0,1-.32-.32v-6.53a.32.32,0,0,1,.32-.32h3a.32.32,0,0,1,.32.32v6.53a.32.32,0,0,1-.32.32.33.33,0,0,1-.32-.32v-6.22Z",
    transform: "translate(-186.62 -241.03)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M641.56,302.15a4.73,4.73,0,0,1,7.09,4.1,4.62,4.62,0,0,1-.11,1,13.31,13.31,0,0,1,2,4,7.15,7.15,0,0,1,6.88,5.43.63.63,0,1,1-1.23.3,5.89,5.89,0,0,0-5.71-4.46h-.38a.63.63,0,0,1-.65-.47,12.4,12.4,0,0,0-2.06-4.28.64.64,0,0,1-.11-.55,3.31,3.31,0,0,0,.14-.95,3.46,3.46,0,0,0-3.46-3.45,3.42,3.42,0,0,0-1.92.58.62.62,0,0,1-.56.07,12.48,12.48,0,0,0-4-.65,12.35,12.35,0,0,0-12.31,11.52.64.64,0,0,1-.64.6h0a5.88,5.88,0,0,0-5.85,5.24.61.61,0,0,1-.28.45.62.62,0,0,1-.53.09,3.3,3.3,0,0,0-1-.13,3.46,3.46,0,0,0-3.45,3.45.64.64,0,0,1-.64.64.64.64,0,0,1-.63-.64,4.72,4.72,0,0,1,4.72-4.73,5.66,5.66,0,0,1,.6,0,7.15,7.15,0,0,1,6.45-5.66,13.62,13.62,0,0,1,13.53-12.15,13.84,13.84,0,0,1,4.1.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M548.24,327.6a17.64,17.64,0,0,1,5.47-.86,17.86,17.86,0,0,1,17.76,16.1,9.28,9.28,0,0,1,8.57,7.55,6,6,0,0,1,7,6,.63.63,0,0,1-.63.63.64.64,0,0,1-.64-.63,4.78,4.78,0,0,0-4.79-4.79,4.71,4.71,0,0,0-1.31.18.62.62,0,0,1-.53-.09.61.61,0,0,1-.28-.45,8,8,0,0,0-8-7.14h0a.62.62,0,0,1-.63-.59,16.6,16.6,0,0,0-21.89-14.6.63.63,0,0,1-.56-.08,4.74,4.74,0,0,0-2.66-.8,4.8,4.8,0,0,0-4.61,6.1.61.61,0,0,1-.1.55,16.58,16.58,0,0,0-2.77,5.75.63.63,0,0,1-.65.47l-.51,0a8,8,0,0,0-7.78,6.08.64.64,0,0,1-.77.47.63.63,0,0,1-.46-.77,9.29,9.29,0,0,1,9-7h.07a17.55,17.55,0,0,1,2.66-5.44,6.06,6.06,0,0,1,9-6.56Z",
    transform: "translate(-186.62 -241.03)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M720.91,339.37a10.9,10.9,0,0,1,3.3-.5,11.12,11.12,0,0,1,11,9.82,5.91,5.91,0,0,1,5.19,4.55l.39,0a4,4,0,0,1,3.94,3.94.64.64,0,1,1-1.27,0,2.68,2.68,0,0,0-2.67-2.67,2.53,2.53,0,0,0-.73.11.62.62,0,0,1-.53-.09.61.61,0,0,1-.28-.46,4.63,4.63,0,0,0-4.6-4.12h0a.64.64,0,0,1-.64-.59,9.83,9.83,0,0,0-13-8.67.65.65,0,0,1-.56-.08,2.72,2.72,0,0,0-1.49-.45,2.67,2.67,0,0,0-2.66,2.67,2.52,2.52,0,0,0,.1.73.66.66,0,0,1-.11.56,9.89,9.89,0,0,0-1.64,3.41.64.64,0,0,1-.66.47h-.29a4.63,4.63,0,0,0-4.49,3.51.65.65,0,0,1-.78.47.64.64,0,0,1-.46-.77,5.9,5.9,0,0,1,5.59-4.48,10.94,10.94,0,0,1,1.54-3.12,3.92,3.92,0,0,1,3.86-4.71,3.89,3.89,0,0,1,1.92.5Z",
    transform: "translate(-186.62 -241.03)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M690.39,251.79a9.89,9.89,0,0,1,3-.44,10,10,0,0,1,10,8.82,5.35,5.35,0,0,1,4.65,4.07h.3a3.6,3.6,0,0,1,3.6,3.6.63.63,0,0,1-.63.64.64.64,0,0,1-.64-.64,2.33,2.33,0,0,0-2.33-2.33,2.3,2.3,0,0,0-.64.09.66.66,0,0,1-.53-.08.65.65,0,0,1-.27-.46,4.09,4.09,0,0,0-4.07-3.64h0a.65.65,0,0,1-.64-.6,8.76,8.76,0,0,0-8.75-8.19,8.57,8.57,0,0,0-2.83.47A.66.66,0,0,1,690,253a2.28,2.28,0,0,0-1.29-.39,2.33,2.33,0,0,0-2.33,2.33,2.25,2.25,0,0,0,.09.64.64.64,0,0,1-.11.55,8.83,8.83,0,0,0-1.46,3,.64.64,0,0,1-.66.48h-.26a4.1,4.1,0,0,0-4,3.1.64.64,0,0,1-.77.47.63.63,0,0,1-.46-.77,5.35,5.35,0,0,1,5-4.07,10,10,0,0,1,1.36-2.76,3.61,3.61,0,0,1,5.27-3.83Z",
    transform: "translate(-186.62 -241.03)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M723.17,367.39l-27-.09a.63.63,0,0,1-.63-.64.64.64,0,0,1,.63-.64l27.62.1a.64.64,0,0,1,.63.64V461a.64.64,0,0,1-.63.64.64.64,0,0,1-.64-.64V367.39Z",
    transform: "translate(-186.62 -241.03)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M699.77,358.05v8.56a.64.64,0,0,1-.63.64.64.64,0,0,1-.64-.64v-9.2a.64.64,0,0,1,.64-.64h13.77a.66.66,0,0,1,.27.06l6.46,3a.64.64,0,0,1,.36.58v5.75a.64.64,0,1,1-1.27,0v-5.35l-6-2.8Z",
    transform: "translate(-186.62 -241.03)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M727.86,389.8h-4.05a.64.64,0,0,1-.64-.64.64.64,0,0,1,.64-.63h4.68a.63.63,0,0,1,.64.63V461a.64.64,0,1,1-1.27,0V389.8Z",
    transform: "translate(-186.62 -241.03)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M732.42,412.07h-3.93a.63.63,0,0,1-.63-.63.64.64,0,0,1,.63-.64h4.16a.67.67,0,0,1,.4.14l2.67,2.15a.62.62,0,0,1,.23.49V461a.64.64,0,0,1-.63.64.64.64,0,0,1-.64-.64V413.89l-2.26-1.82Z",
    transform: "translate(-186.62 -241.03)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M701.39,352v5.46a.64.64,0,1,1-1.27,0v-6.1a.64.64,0,0,1,.64-.64H710a.64.64,0,0,1,.64.64v6.1a.64.64,0,1,1-1.28,0V352Z",
    transform: "translate(-186.62 -241.03)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M706,351.31V335.18a.63.63,0,0,0-.63-.63.64.64,0,0,0-.64.63v16.13a.64.64,0,0,0,.64.64.64.64,0,0,0,.63-.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M726.42,379.11h-2.61a.64.64,0,0,1-.64-.63.64.64,0,0,1,.64-.64h3.25a.64.64,0,0,1,.64.64v10.68a.64.64,0,0,1-1.28,0V379.11Z",
    transform: "translate(-186.62 -241.03)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M598.8,403v58a.64.64,0,0,1-.63.64.64.64,0,0,1-.64-.64v-58.3a.62.62,0,0,1,.22-.48l25.07-21.92a.62.62,0,0,1,.41-.16h31.13a.64.64,0,1,1,0,1.27H623.47L598.8,403Z",
    transform: "translate(-186.62 -241.03)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M591.34,412.36V461a.64.64,0,0,1-.64.64.64.64,0,0,1-.63-.64V411.73a.63.63,0,0,1,.63-.64h7.47a.64.64,0,0,1,.63.64.63.63,0,0,1-.63.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M551.14,432v29a.64.64,0,0,1-.63.64.64.64,0,0,1-.64-.64V431.31a.64.64,0,0,1,.64-.63H590.7a.64.64,0,0,1,.64.63.64.64,0,0,1-.64.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M556,427.59v3.72a.64.64,0,0,1-1.28,0v-4.15a.64.64,0,0,1,.41-.59l6.3-2.52a.67.67,0,0,1,.24,0H587.6a.64.64,0,0,1,.64.63v6.67a.64.64,0,0,1-.64.64.64.64,0,0,1-.63-.64v-6H561.79L556,427.59Z",
    transform: "translate(-186.62 -241.03)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M545.74,437v24a.64.64,0,0,1-.64.64.64.64,0,0,1-.63-.64V436.34a.63.63,0,0,1,.63-.63h5.41a.63.63,0,0,1,.63.63.64.64,0,0,1-.63.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M628.16,375.09v5.65a.64.64,0,0,1-1.27,0v-6a.65.65,0,0,1,.26-.52l4.86-3.51a.61.61,0,0,1,.37-.12H650.9a.63.63,0,0,1,.63.64v9.48a.63.63,0,0,1-.63.63.64.64,0,0,1-.64-.63v-8.85H632.58l-4.42,3.2Z",
    transform: "translate(-186.62 -241.03)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M637.21,361.08v10.18a.63.63,0,0,1-.63.63.64.64,0,0,1-.64-.63V360.45a.64.64,0,0,1,.64-.64h11.07a.64.64,0,0,1,.63.64v10.81a.64.64,0,0,1-1.27,0V361.08Z",
    transform: "translate(-186.62 -241.03)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M642.75,360.45V336.54a.64.64,0,0,0-1.28,0v23.91a.64.64,0,0,0,1.28,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M571.24,413.39v11.25a.64.64,0,1,1-1.27,0V412.75a.64.64,0,0,1,.63-.64h13.57a.64.64,0,0,1,.63.64v11.89a.64.64,0,0,1-.63.64.64.64,0,0,1-.64-.64V413.39Z",
    transform: "translate(-186.62 -241.03)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M578,412.75V381.22a.63.63,0,0,0-.63-.63.64.64,0,0,0-.64.63v31.53a.64.64,0,0,0,.64.64.64.64,0,0,0,.63-.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M566.62,417.72v6.92a.64.64,0,0,1-.63.64.64.64,0,0,1-.64-.64v-7.56a.64.64,0,0,1,.64-.63h4.61a.64.64,0,1,1,0,1.27Z",
    transform: "translate(-186.62 -241.03)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M519.25,400.26v6.66a.64.64,0,0,1-1.27,0v-7a.63.63,0,0,1,.34-.56l5.42-2.89a.6.6,0,0,1,.29-.08h18a.64.64,0,0,1,.64.64v9.77a.64.64,0,1,1-1.27,0v-9.14H524.19l-4.94,2.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M529.34,390.16V397a.63.63,0,0,1-.63.63.64.64,0,0,1-.64-.63v-7.47a.64.64,0,0,1,.64-.63h10.74a.63.63,0,0,1,.64.63V397a.64.64,0,0,1-.64.63.63.63,0,0,1-.63-.63v-6.83Z",
    transform: "translate(-186.62 -241.03)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M534.72,389.52v-19a.64.64,0,0,0-1.28,0v19a.64.64,0,1,0,1.28,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M480.31,380.64v8.88a.64.64,0,0,1-.64.64.64.64,0,0,1-.63-.64V380a.64.64,0,0,1,.63-.64h8.25a.56.56,0,0,1,.31.09l15.22,8.75a.65.65,0,0,1,.32.56v11.42a.64.64,0,0,1-1.27,0V389.13l-14.75-8.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M505.8,393.37v7.91a.64.64,0,1,1-1.27,0v-9a.64.64,0,0,1,1-.56l5.75,3.24a.62.62,0,0,1,.32.55v8.86a.64.64,0,0,1-.64.63.63.63,0,0,1-.63-.63v-8.48l-4.48-2.52Z",
    transform: "translate(-186.62 -241.03)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.83,374.81V380a.63.63,0,0,1-.63.63.64.64,0,0,1-.64-.63v-5.84a.64.64,0,0,1,.64-.63h5.1a.63.63,0,0,1,.63.63V380a.63.63,0,0,1-.63.63.64.64,0,0,1-.64-.63v-5.2Z",
    transform: "translate(-186.62 -241.03)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M484.38,374.17V359.35a.64.64,0,0,0-.63-.64.64.64,0,0,0-.64.64v14.82a.64.64,0,0,0,.64.64.64.64,0,0,0,.63-.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M508.68,393.8V373.27a.64.64,0,1,0-1.28,0V393.8a.64.64,0,0,0,1.28,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,370.86h27.62a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H696.19a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,379.13h27.62a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32H696.19a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,391.42h27.62a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32H696.19a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,407.71h27.62a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32H696.19a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.18,435.77h23.63a.32.32,0,0,0,0-.64H700.18a.32.32,0,0,0,0,.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,423.85h27.62a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H696.19a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.18,451.9h23.63a.32.32,0,1,0,0-.63H700.18a.32.32,0,0,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,374.84h27.62a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32H696.19a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,387.13h27.62a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32H696.19a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,403.42h27.62a.32.32,0,0,0,.32-.32.33.33,0,0,0-.32-.32H696.19a.33.33,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.18,431.48h23.63a.32.32,0,1,0,0-.64H700.18a.32.32,0,0,0,0,.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,419.56h27.62a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H696.19a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.18,447.61h23.63a.32.32,0,1,0,0-.63H700.18a.32.32,0,0,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,383h27.62a.32.32,0,0,0,0-.64H696.19a.32.32,0,1,0,0,.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,399.3h27.62a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H696.19a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,415.43h27.62a.32.32,0,1,0,0-.63H696.19a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.18,443.49h23.63a.32.32,0,1,0,0-.63H700.18a.32.32,0,0,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,395.3h27.62a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H696.19a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M696.19,411.59h27.62a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H696.19a.32.32,0,0,0-.32.32.33.33,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.18,439.65h23.63a.33.33,0,0,0,.32-.32.32.32,0,0,0-.32-.32H700.18a.31.31,0,0,0-.31.32.32.32,0,0,0,.31.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.18,427.72h23.63a.32.32,0,1,0,0-.63H700.18a.32.32,0,0,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.18,455.78h23.63a.32.32,0,1,0,0-.63H700.18a.32.32,0,0,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.48,389l-25.1,22a.33.33,0,0,1-.45,0,.32.32,0,0,1,0-.45l25.19-22.06a.32.32,0,0,1,.21-.08h31a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.48,421.17l-25.1,22a.33.33,0,0,1-.45,0,.32.32,0,0,1,0-.45l25.19-22.06a.32.32,0,0,1,.21-.08h31a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.48,453.18l-9.16,8a.33.33,0,0,1-.45,0,.31.31,0,0,1,0-.45l9.25-8.1a.32.32,0,0,1,.21-.08h27a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.48,405l-25.1,22a.33.33,0,0,1-.45,0,.32.32,0,0,1,0-.45l25.19-22.06a.32.32,0,0,1,.21-.08h31a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.48,437.23l-25.1,22a.33.33,0,0,1-.45,0,.32.32,0,0,1,0-.45l25.19-22.06a.32.32,0,0,1,.21-.08h27a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.48,397l-25.1,22a.33.33,0,0,1-.45,0,.32.32,0,0,1,0-.45l25.19-22.06a.32.32,0,0,1,.21-.08h31a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.48,429.2l-25.1,22a.33.33,0,0,1-.45,0,.32.32,0,0,1,0-.45l25.19-22.06a.32.32,0,0,1,.21-.08h27a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.48,413.07l-25.1,22a.33.33,0,0,1-.45,0,.32.32,0,0,1,0-.45l25.19-22.06a.32.32,0,0,1,.21-.08h31a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.48,445.26,605.27,461.2a.32.32,0,0,1-.42-.48l18.3-16a.32.32,0,0,1,.21-.08h27a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.1,380.74V461a.32.32,0,0,0,.32.32.32.32,0,0,0,.32-.32V380.74a.32.32,0,0,0-.32-.32.32.32,0,0,0-.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M550.51,438.79H590.7a.32.32,0,0,0,.32-.32.32.32,0,0,0-.32-.32H550.51a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M550.51,450.45H590.7a.32.32,0,1,0,0-.63H550.51a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M550.51,445.08H590.7a.32.32,0,0,0,.32-.32.32.32,0,0,0-.32-.32H550.51a.32.32,0,0,0-.32.32.32.32,0,0,0,.32.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M550.51,456.74H590.7a.32.32,0,1,0,0-.63H550.51a.32.32,0,1,0,0,.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.47,397.12h-4.74a.32.32,0,1,1,0-.63h4.82a.32.32,0,0,1,.14,0L515.52,414H545.1a.32.32,0,1,1,0,.63H515.44l-.15,0-33.82-17.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.47,425.61h-4.74a.32.32,0,0,1,0-.64h4.82a.23.23,0,0,1,.14,0l33.83,17.43H545.1a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32H515.44l-.15,0-33.82-17.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.47,411.15h-4.74a.32.32,0,1,1,0-.63h4.82a.32.32,0,0,1,.14,0L515.52,428H545.1a.32.32,0,1,1,0,.63H515.44a.4.4,0,0,1-.15,0l-33.82-17.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.47,439.64h-4.74a.32.32,0,0,1,0-.64h4.82a.23.23,0,0,1,.14,0l33.83,17.43H545.1a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32H515.44a.28.28,0,0,1-.15,0l-33.82-17.43Z",
    transform: "translate(-186.62 -241.03)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.47,404.4h-4.74a.32.32,0,1,1,0-.63h4.82a.32.32,0,0,1,.14,0l33.83,17.44H545.1a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32H515.44a.42.42,0,0,1-.15,0L481.47,404.4Z",
    transform: "translate(-186.62 -241.03)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.47,432.89h-4.74a.32.32,0,0,1-.32-.32.32.32,0,0,1,.32-.32h4.82a.33.33,0,0,1,.14,0l33.83,17.44H545.1a.32.32,0,1,1,0,.63H515.44a.4.4,0,0,1-.15,0l-33.82-17.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.47,418.43h-4.74a.32.32,0,1,1,0-.63h4.82a.32.32,0,0,1,.14,0l33.83,17.44H545.1a.32.32,0,0,1,.32.32.32.32,0,0,1-.32.32H515.44a.42.42,0,0,1-.15,0l-33.82-17.44Z",
    transform: "translate(-186.62 -241.03)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.47,446.92h-4.74a.32.32,0,0,1-.32-.32.32.32,0,0,1,.32-.32h4.82a.33.33,0,0,1,.14,0l27.85,14.36a.32.32,0,0,1,.14.43.32.32,0,0,1-.43.13l-27.78-14.32Z",
    transform: "translate(-186.62 -241.03)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.47,453.77h-4.74a.32.32,0,1,1,0-.63h4.82a.32.32,0,0,1,.14,0l14.54,7.49a.33.33,0,0,1,.13.43.32.32,0,0,1-.43.14l-14.46-7.46Z",
    transform: "translate(-186.62 -241.03)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.58,389.52V461a.32.32,0,1,0,.64,0V389.52a.32.32,0,1,0-.64,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M515.17,407.12V461a.32.32,0,1,0,.63,0V407.12a.32.32,0,1,0-.63,0Z",
    transform: "translate(-186.62 -241.03)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M711.23,267.2H693.35a.64.64,0,1,0,0,1.27h17.88a.64.64,0,0,0,0-1.27Z",
    transform: "translate(-186.62 -241.03)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M703.64,270.26H686.39a.64.64,0,1,0,0,1.27h17.25a.64.64,0,0,0,0-1.27Z",
    transform: "translate(-186.62 -241.03)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M744.13,356.53H726.38a.64.64,0,0,0-.64.63.64.64,0,0,0,.64.64h17.75a.64.64,0,0,0,.64-.64.63.63,0,0,0-.64-.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M733,359h-9.95a.64.64,0,1,0,0,1.27H733a.64.64,0,1,0,0-1.27Z",
    transform: "translate(-186.62 -241.03)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M612.79,324.66h23.27a.64.64,0,0,0,.63-.64.63.63,0,0,0-.63-.63H612.79a.63.63,0,0,0-.63.63.64.64,0,0,0,.63.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M630.06,327.33h19.17a.64.64,0,0,0,.64-.64.64.64,0,0,0-.64-.63H630.06a.64.64,0,0,0-.64.63.64.64,0,0,0,.64.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M586.43,355.74H553.26a.64.64,0,0,0,0,1.27h33.17a.64.64,0,0,0,0-1.27Z",
    transform: "translate(-186.62 -241.03)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M564.3,358.3H538.47a.64.64,0,1,0,0,1.27H564.3a.64.64,0,1,0,0-1.27Z",
    transform: "translate(-186.62 -241.03)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M586.43,259.47a24.1,24.1,0,1,0,24.1,24.1,24.11,24.11,0,0,0-24.1-24.1Zm0,1.27a22.83,22.83,0,1,1-22.83,22.83,22.84,22.84,0,0,1,22.83-22.83Z",
    transform: "translate(-186.62 -241.03)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M568.59,288.28a18.19,18.19,0,0,1-.58-3.64.63.63,0,0,0-.67-.59.64.64,0,0,0-.6.67,20.1,20.1,0,0,0,.62,3.89.64.64,0,0,0,1.23-.33Z",
    transform: "translate(-186.62 -241.03)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M568.13,281.2a18.46,18.46,0,0,1,7.74-12.76.63.63,0,0,0,.16-.88.64.64,0,0,0-.89-.16A19.72,19.72,0,0,0,566.87,281a.65.65,0,0,0,.55.72.63.63,0,0,0,.71-.55Z",
    transform: "translate(-186.62 -241.03)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M467.9,461.6H747.51a.64.64,0,1,0,0-1.28H467.9a.64.64,0,0,0,0,1.28Z",
    transform: "translate(-186.62 -241.03)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M478.71,466H730.27a.64.64,0,0,0,.63-.64.63.63,0,0,0-.63-.63H478.71a.64.64,0,0,0-.64.63.64.64,0,0,0,.64.64Z",
    transform: "translate(-186.62 -241.03)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M715.72,469.5H559a.64.64,0,1,0,0,1.27H715.72a.64.64,0,0,0,0-1.27Z",
    transform: "translate(-186.62 -241.03)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M666.16,412l-3.43-6-7-4.38-6.5-.7-6.43,1.34-4.8,3.21-4,6.23-1,5.85,1.6,8.05,6.17,8.38,8.89,14.88,1.16-.8,5-8.91,6.68-9.36,3.61-6.86,1-6.15ZM650.4,426.07a8.26,8.26,0,1,1,8.25-8.26A8.25,8.25,0,0,1,650.4,426.07Z",
    transform: "translate(-186.62 -241.03)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620.85,455.88l8.91-12.38,15.51-.45,5.07,8.38,3.21-8.38,15.15.36,3.21,2L679,457.13l-1.25,2.8s-2,1-2.32,1.12-53-1.12-53-1.12l-2.05-2.09Z",
    transform: "translate(-186.62 -241.03)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M679.14,454.59l-4.67-7.2c-4.15-6.25-4-5.23-14.1-5.23-1.66,0-2.53.41-4.16,0-.31-1.71,3.34-6.35,4.63-8l3.67-5.4c1.72-3.12,3.38-4.8,3.59-10.11a21.2,21.2,0,0,0-.3-4A18.26,18.26,0,0,0,661,403.27a32.51,32.51,0,0,0-3-1.72c-3.82-2.29-10.11-2.28-14.7-.61a18.48,18.48,0,0,0-6,4c-6.19,5.61-6.83,15.38-2.47,22.91.57,1,1.27,1.89,1.86,2.86,1.37,2.27,6.43,8.95,6.74,11.35-1.39.36-9.63.24-10.92.12-4.3-.38-7.32,5.76-9.38,9-.84,1.34-3.31,4.77-3.48,5.94a3.81,3.81,0,0,0,1.21,3.48,6.8,6.8,0,0,0,3.51,1.33h51c2.24,0,5.09-1.33,5.08-4.23C680.48,456.41,679.71,455.61,679.14,454.59Zm-37.87-20.65c-1.55-2.47-2.92-4.39-4.27-6.66-3.11-5.23-2.94-5.37-2.94-11.19,0-3.95,2.66-7.73,5.15-10.21a16,16,0,0,1,11.16-4.28c12.87.11,20.34,15.2,12.73,25.67L654,440.7c-.74,1.27-1.34,2.16-2.08,3.53-.85,1.57-.73,2.77-2.64,3.31Zm37,24.67a3.35,3.35,0,0,1-2.52,1.32H625c-6.3,0-2-4.56,0-8.11l3-4.54c1.09-1.62,2-3.12,4.49-3.12h11c3.92,0,4.14,6.89,6.57,8,2.31-1,1.87-8,5.64-8h12.2c3.16,0,4.57,4.11,7,7.54C676.23,453.69,679,457.12,678.23,458.61Z",
    transform: "translate(-186.62 -241.03)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M659.61,417c-.07-8.18-10.74-12-16.29-5.75-1.32,1.49-2.79,4.41-2.43,7C642.57,430.37,659.71,429.71,659.61,417Zm-15.12-4,1.42-1.36a6,6,0,0,1,2.58-1.3c4.45-1.3,8.2,2.06,9.11,5.32a7.72,7.72,0,0,1-5.43,9.1C644.69,426.25,640.26,418.22,644.49,413Z",
    transform: "translate(-186.62 -241.03)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "192.52 113.23 197.11 94.62 217.97 98.37 216 102.02 221.35 111.73 204.6 122.96 197.65 112.71 192.93 114.49 192.52 113.23"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M350.58,364.34a16.8,16.8,0,0,0,1.79-2.07c.09-.33,2.05-4.17,2.22-4.61a14.59,14.59,0,0,1,2.32-2.94,20.07,20.07,0,0,0,2-3.41s.36-1.23,0-1.76-3.12-7-3.12-7l.36-5.75,5.17-3.49a6.51,6.51,0,0,1,2.22-.8,21,21,0,0,1,4.19.8c1.16.36,6.8,1.81,6.8,1.81l2.39,4.79a10.2,10.2,0,0,1,1.15,3.2c0,1.07-.18,4.28-.18,4.28l-3.25,5.21-7.09.67h-1.42l-8.82,15.53L351.92,370l-2.23-4Z",
    transform: "translate(-186.62 -241.03)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M401.13,339c4.29.48.67,2.72-.21,3.85a21.75,21.75,0,0,0,2.76,4.61c.55.85.84,1.47,1.44,2.3a4.49,4.49,0,0,1,1.23,2.51,14.86,14.86,0,0,1-1.87,1.48l-5.65,3.77c-1.4,1.1-2.26,1.47-3.69,2.55-.59.45-1.18.77-1.86,1.28-1.48,1.12-2,1.34-3.13-.36l-4.67-7.22c-2.22-2.67-2,.83-4.6-.11-.46-1.62.72-3.81,1-5.26,1.07-5.94,5.75-2.62,7.67-4.9a2.08,2.08,0,0,0-1.59-3.49c-2.48,0-1.85,1-3.06,2.58l-1.31-.4c-.17-.71.36-2.2.54-3.15.33-1.75.29-2.33,2.24-2.25L401.13,339Zm-49,29.65c-1.74-4.15-.32-3.54,1.71-4.78l-.25-2.73c.78-.47,1.68-1,2.35-1.47-.06-1.36-.47-2.26.25-2.85,2.25-1.83.44,1.19,3.5-4,2.42-4.13.42-3.05-1.65-6.63-3.47-6,.8-12,4.86-12.09,1.22,1.31,3.35,7.13,4.9,7.72,1.86.72,3.27-.94,2.8-2.88s-2.76-1.14-3.86-2.39c-.93-1.05-2.15-4,2.46-2.12,2.11.87,1.07,0,3.06,1.61,7.31,5.79,5,13.66-.31,15.62-2.12.79-3.26.64-5.46.5-2-.13-3.48,4.13-5.07,7.1-2.63,4.93-4.4,10.48-9.29,9.43Zm12.5-41.13c0-3.56,2.45-7.37,4.18-9.12,3.94-4,6.79-4.41,11.93-4.41,4,0,8.82,3.69,10.93,7.3,3.38,5.77,1.82,14-.29,14-2.87,0-6.89-1.29-7.82-.7-1.3,1.6-1.07,2.92-1.7,5-1.14,3.78-.37,3.9-2.8,3.93a18,18,0,0,0-1.81-5.32,16,16,0,0,0-8.17-6.19c-3.81-.95-4.45.7-4.45-4.49Zm-2.25,4.23c-7.87,2.54-9.57,9.64-6,15.82,1.13,2,3.17,2.74.1,6.35-1.36,1.62-.47-.12-3.25,1.74l.19,2.53c-1,1.21-1.41.44-2.08,1.23s-.21,1.7-.19,2.84c-1.26,1.88-3.13.17-2.07,3.82,1.7,5.83.59,6.41,8.16,3.92,1.53-.5,2.13-2.5,3.38-4.73l5.88-10.72c4.25-.14,5.57-.39,8.47-2.17a8.26,8.26,0,0,0,2.61-2.71c.28-.5.52-1.15.79-1.72.62-1.32.46-1.24,1.16-1.78l.27.53c0,.07.07.18.09.27l.06.29c.09.93-.54,2-.82,3.34a20.77,20.77,0,0,0-.95,4.46c1.36,3,3.32,1,5.42.47,2.9,2.15,5.64,10.14,7.86,9.58l14.19-9.57c5-3.43,4.08-2.33,1.3-6.95a40.17,40.17,0,0,1-2.79-4.42c-.89-2.29,2.19-2.33,1.48-4.89-.91-3.27-9.64-2.2-10.75-3.64-.65-.85,3.43-9.2-2.22-16.87-2.74-3.71-4.59-4.56-8.29-6.12-5.47-2.31-12.24-.11-16.49,3.54a14.88,14.88,0,0,0-3.13,4.07c-2.32,3.79-2.2,6.76-2.34,11.49Z",
    transform: "translate(-186.62 -241.03)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M393.77,354.26c-1.28-.67-3.3-3.61-3.13-4.7.21-1.36,3.29-2.94,4.75-3.32,1.52,1.25,2.05,2.94,3.2,4.46-.78,1.4-2.9,3.44-4.82,3.56ZM392.56,358c2.81-.3,3-1.35,5.15-2.58a27.59,27.59,0,0,0,4.5-3.12c-.26-1.88-3-5.88-4-7.67-2.59-4.44-4.35-.78-8.28,1.37-2.43,1.33-4,2.11-2.12,5,1.77,2.68,2.66,4.56,4.77,7Z",
    transform: "translate(-186.62 -241.03)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "410.88 57.53 414.97 53.67 426.19 64.57 422.01 69.26 410.65 57.99 410.88 57.53"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M598.6,299c.31-.58,0-.12.43-.61,3.07-3.71,2.92-2.3,6.26,1l3.15,3.15c3.56,3.55,3.93,2.87,1.76,5a15.16,15.16,0,0,1-1.57,1.47c-1.24-.67-9.44-8.84-10-10.07ZM568,281.76c0-1.52,1.4-5.46,2-6.66a18.83,18.83,0,0,1,16.1-9.83,17.63,17.63,0,0,1,12.82,5.59c6,5.94,7.05,15.93,2,22.77a15.11,15.11,0,0,1-4.46,4.51,18.36,18.36,0,0,1-10.07,3.36A17.94,17.94,0,0,1,571.47,294c-3.16-4.27-3.49-7.38-3.49-12.2Zm-1.55.48a18.3,18.3,0,0,0,2.06,9.64,15.23,15.23,0,0,0,1.58,3,20.53,20.53,0,0,0,15.31,8.2,23.76,23.76,0,0,0,7.74-1.4l3.09-1.55c1.13-.41,2.14,1,2.79,1.71,1.74,1.74,8.11,8.38,9.63,9.34.7-.6,5.14-4.75,5.07-5.4a5.2,5.2,0,0,0-1.26-1.4c-1.24-1.21-9.81-9.58-9.86-10.23,0-.14,3-5.58,3-9.21,0-4-.09-6.42-2.12-10.34a17.92,17.92,0,0,0-6.65-7.4c-3.71-2.11-5.3-3.27-10.95-3.26-8.43,0-13.75,4.45-17.38,10.88a22.27,22.27,0,0,0-2,7.45Z",
    transform: "translate(-186.62 -241.03)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M573.81,282.65c1.25.18,1.18,0,1.8-.72a66.59,66.59,0,0,1,7-6.32c4-3.05,2.07-3.55,6.48.5,4.08,3.74,3.13-.12,3.13,14.86,0,1-.27,1.23-1.26,1.23-3.07,0-9.2.2-11.92-.17-.43-1.68-.06-7.14-.19-7.85-.19-1,.23-.36-.45-.78,0,0-.24-.78-.79.2-.27.48-.31,7.46-.31,8.34,0,1.21.16,1.62,1.3,1.62h14.29c1.43,0,.88-4.4.88-5.74,0-1.79-.21-5.43.14-7,1.83,0,1.45,2,3.35,1.84,1.06-1.36-1.29-2.25-2.92-4.06-1.43-1.57.19-5.05-1-7-2.12.23-.76,1.67-1.17,3.66-.24,1.21-.42.95-1.29.26l-2.79-2.32c-.44-.4-.84-.84-1.37-1.31-1.52-1.34-2.15,0-3.2.77a6.81,6.81,0,0,0-1.35,1.07l-6.66,6.2c-1.19,1-2.23,1-1.72,2.72Z",
    transform: "translate(-186.62 -241.03)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M583.48,284.42c0-1.89,2.81-1.37,3.85-1a6,6,0,0,1-.07,3.65c-3.82.69-3.78,0-3.78-2.63Zm-1.55-1.21c0,2.85-.37,4,.64,5.47,7.87.4,6.34-.11,6.33-3.29,0-4.39,1.36-3.65-5.47-3.65-1.14,0-1.5.32-1.5,1.47Z",
    transform: "translate(-186.62 -241.03)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "347.55 140.56 352.2 141.59 345.46 172 342.21 175.66 339.75 171.85 346.67 140.65 347.55 140.56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 493.45,
    y: 372.6,
    width: 30.9,
    height: 45.75,
    transform: "matrix(0.98, 0.22, -0.22, 0.98, -89, -341.77)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M490.15,413.4c.47-3.39,1.63-7.58,2.39-11l6.16-27.76c.65-2.95.39-4.15,2.2-3.75l25.38,5.63a3.75,3.75,0,0,1,1.61.82l-9.1,41.33c-.19.88,0,1-.95,1.19s-18.84-4-20.83-4.45-5.45-.64-6.86-2Zm8-43.37c-1.09,4.89-10,43.41-9.75,44.91,1.57.78,22.84,5.18,28,6.34,1.15.26,3.21,1,3.48-.15L529.62,377c.43-1.95-1-1.58-2.26-1.88s-2.75-.78-4.26-1.12c-6.06-1.34-16.22-3.8-21.94-4.72-1.31-.21-2.57-1.37-3,.74Z",
    transform: "translate(-186.62 -241.03)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M536.93,388c-.15,3.18-4.26,20.15-5.24,24.58-.73,3.27-5.22,3.78-3.91-2.11l5.11-22.64c.41-.85.89-.8,1.77-.69a5,5,0,0,1,2.27.86Zm-2.39-5.57c2.29.27,4.63.78,2.86,3.57a11.82,11.82,0,0,1-3.14-.54c-1.3-.28-.3-2.42.28-3Zm-1.92-1-6.52,29.41c-1.05,4.76,1.95,4,1.33,7.1-.41,2.05-.63.85.58,1.93,1.84-1.56.25-2.24,2-3.21,3.89-2.11,3.31-4.44,4.94-11.81l3.2-14.49c.45-2,1-2.78,2.39-1.35a45.54,45.54,0,0,1-1.24,6.1c-.44,2-1.72,4.73.51,4.65.81-1.09,2.25-9,2.67-10.91.51-2.32-1.65-1.55-3.26-2.45-.2-2.28,2-4.43-.74-4.85-3.51-.53-5.52-1.82-5.9-.12Z",
    transform: "translate(-186.62 -241.03)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M498.47,387.92c1.06.49,1.21.14,1.88-.3,2.44-1.58,5.74-3.1,6.63-3.66s4.41-2.91,5.29-2.6c.48.18,5.16,6.65,5,7.58l-2.47,11.15a1.23,1.23,0,0,1-1.58.78c-13.49-3-12-1.59-10.88-6.52.36-1.63,1-3.58.77-5.05-1.2-.21-1.5.26-1.74,1.35l-1.68,7.59a1.26,1.26,0,0,0,1.05,1.66c3.38.74,11.94,3,14.83,3,.86-1.89,1.59-6.26,2.11-8.61.16-.72.3-1.46.46-2.17.23-1,.16-1.6,1.12-1.14,1.14.54.89,2.76,2.39,1.89s-1.8-3.33-2.3-4.93c-.77-2.46,2.84-6.41-.25-6.74-.62,1.54-.59,2.59-1.28,4-1.19-.49-1.45-1.37-2.15-2.27l-1.83-2.5c-1.18-1.83-1.42-1.34-4-.06l-6.59,3.74c-.87.52-1.68,1-2.66,1.57-2,1.19-2,.65-2,2.27Z",
    transform: "translate(-186.62 -241.03)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M507.63,391.8c.22-1,.74-.95,1.74-.73,1.67.37,2.34.3,2,1.81-.25,1.14-.28,2.35-1.38,2.11-3-.66-3-.4-2.36-3.19Zm-2.36,3.45c1.33,1.08,2.75,1.09,5.06,1.61s1.72.13,3-5.55a2.48,2.48,0,0,0,0-1.05c-1.23-.48-5.86-1.89-6.75-.9l-1.3,5.89Z",
    transform: "translate(-186.62 -241.03)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M511.12,412.36l-5.22-1.16c-1.8-.4-8.55-2.38-9.78-1.54.06,1.09.13,1,1.35,1.3,2.66.58,15.94,3.71,16.47,3.46,1.81-1.43-1.43-1.76-2.82-2.06Z",
    transform: "translate(-186.62 -241.03)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M514.4,409.9c.54.12.66,0,1-.21l.15-.7a2,2,0,0,0-1.06-.66l-15.89-3.52c-1.18-.26-1.15,0-1.6.76a1.81,1.81,0,0,0,1,.7l16.36,3.63Z",
    transform: "translate(-186.62 -241.03)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 450.09,
    y: 119.5,
    width: 10.83,
    height: 10.83
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 479.57,
    y: 51.09,
    width: 18.65,
    height: 9.98
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 159.74,
    y: 51.37,
    width: 5.22,
    height: 6.78
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 147.92,
    y: 51.97,
    width: 5.75,
    height: 6.19
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 136.22,
    y: 51.73,
    width: 6.29,
    height: 6.29
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 244.94,
    y: 172.48,
    width: 4.88,
    height: 46.69
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 136.93,
    y: 66.77,
    width: 4.83,
    height: 131.71
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 148.35,
    y: 66.77,
    width: 4.83,
    height: 131.71
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 159.7,
    y: 66.77,
    width: 4.83,
    height: 131.71
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "135.01 215.48 135.01 201.18 131.32 197.44 150.01 181.79 160.45 189.58 160.45 181.79 165.58 182.08 165.58 194.6 168.99 198.23 166.22 201.06 168.7 210.52 168.04 213.58 166.22 217.4 162.18 219.4 158.78 219.4 154.97 218.13 136.68 217.67 135.07 216.52 135.01 215.48"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M352.86,456.67c-.1.12-.42.48-.58.64-3.5,3.44-6.83,3.25-10.65.3L331.58,450c-.63-.89-.39-2,.93-2,3.23,0,3.58,2.21,5.47,2.27a2,2,0,0,0,.18-.8,8.09,8.09,0,0,0-.71-2.12c-.28-.82-.42-1-.72-1.88-.23-.67-.43-1.16-.72-1.95-.22-.59-.24-.46-.43-1-.49-1.29-2.46-5.84-2.25-6.84a1.5,1.5,0,0,1,1.41-1.18c2.73,0,2.95,7,4.66,7.29,1.36-.21.63-1,2-1.13s.95.68,2.22,1c1.08-.39.93-1.37,2-1.47s1.33.66,2.23,1.08c.75-.64,1.34-2,2.62-1.56s1.18,1.6,1.64,2.85c.38,1.06.71,2.31,1.07,3.59,1,3.51,2.77,6.54-.4,10.48Zm-33.5-17.25a6.13,6.13,0,0,1,2-2.29c.8-.69,1.52-1.52,2.23-2a20.79,20.79,0,0,0,2.29-2l5.57-5c.41-.36.69-.58,1.07-.95l4.38-3.85c.82.25,1.43,1.15,2.77,2.1a30.22,30.22,0,0,1,2.53,2.34c.87.84,1.63,1.42,2.55,2.31.72.7,1.68,1.85,2.8,1.6.48-1.6-.19-7,.54-8.14a5.54,5.54,0,0,1,3.37,0c1,3.25-.88,11.54.77,13.18a12.3,12.3,0,0,0,1.3,1.16c1.3,1,1.22,1.94-.17,2.54-1-.71-1.14-1.91-2.73-2.14-2.12-.31-1.91,1-3.64.66-2.94-.54-2.3.26-3.47.59-1.32.39-.07-1.05-3.72.06-.77-.72-1.73-3.8-2.38-5.07a3,3,0,0,0-4.88-.51c-1.42,1.59-.11,4.1.49,5.73l2,5.26c.4,1,1.3,2.39-.7,1.78-4.46-1.37-6,2.17-3,4.76l6.37,4.76c.82.68,1.62.77,1.68,2h-13.2c-1.29,0-2.9.27-3.52-.7s-.27-10.26-.27-12.65c0-1.32.21-3-.2-3.74-1.95-.44-.92.12-2.88-1.88Zm27-10.39c-1,0-.4,0-.94-.3l-.6-.42-3.49-3.2c-1.5-1.45-3.7-3.95-5.05-3.11-.72.45-1.39,1.48-2.35,2.12L318.7,437.71c-3.15,2.33,2.25,3.53,2.44,6.52s-.17,5.86-.16,8.5c0,3.32-.58,5.88,2,6.87,1.41.53,14.81.26,17.39.24,2.42,0,1.87.15,3.62.83,5.63,2.17,12.14-2.72,11.95-9.15-.07-2.24-1.23-5-1.76-6.93s-.84-1.79.48-3.1c.45-.45.65-.69,1.06-1.16,1.46-1.67-.13-2.4-2-4.14-1.07-1-.93-2.47-.77-4.12.11-1.14.15-9.1-.05-9.64-.8-.52-1.91-.34-3.16-.34-.59,0-1.27,0-1.84,0a2.12,2.12,0,0,0-.76.09c-1.74.57-.21,4.2-.82,6.86Z",
    transform: "translate(-186.62 -241.03)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M340.4,458l-7.26-5.77-2.77-2.83.63-1.79h3.64l2.13.52-4.1-11.48.24-2a6.85,6.85,0,0,1,1.15-.68c.17,0,1.85.41,1.85.41l3.46,5.82,1.5.18a2.8,2.8,0,0,1,1.67-.18,9.11,9.11,0,0,0,3-.4h2.94A7.23,7.23,0,0,1,350,439c.17.06,2.48,1.88,2.48,1.92s.52.62.52.62l1.68-1.28.95-1-3.41-3.64-.08-12.8-4.73.53-.32,7.25-10-7.78-1.53.53L317.94,439.2l3.66,3.4.09,14.94,1.35,1.33,4.56.52,12-.4Z",
    transform: "translate(-186.62 -241.03)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 60.9,
    y: 138.45,
    width: 10.83,
    height: 75.56
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.07,405.94l-4.85-4.86-1.28-5.77,2.49-6.35,6.07-5,5.7-1.28,5.64,2.21,2.85,2.93,5.14-4.18s5.42-1.1,5.63-1,6.18,1.19,6.18,1.19l3.45,4.16,3.35,3.92,1.64,4.78-.35,2.86-1.79,4.56L250,407.93l1.14,2.78-.57,1.81-2.35,1.76-1.14.36-1.72,2.71-1.92.95-1.57.33-.79,2.42-1.56.77-3.79-.77-4.19,4.64H228.9L227.14,424l-.66-1.71-3.07-.45a11,11,0,0,1-1.6-1.69c0-.29-.75-2.64-.75-2.64s-2.07-.22-2.28-.29a9.06,9.06,0,0,1-1.57-1.35,17,17,0,0,1-.36-2.28l-3.53-.58-.82-3.49a8.47,8.47,0,0,1,.82-2.14A5.65,5.65,0,0,0,214.07,405.94Z",
    transform: "translate(-186.62 -241.03)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M234.39,421.66s-.68.62-.9.87l-2.7,2.6a2.39,2.39,0,0,1-3.08-3.13,16.93,16.93,0,0,1,3.52-3.5c2.28-1,4.08,1.88,3.16,3.16Zm-3.06-6.13c-.38.86-3.26,3.45-4.31,4.53-2.53,2.59-5.15-.21-4-2.28a52.66,52.66,0,0,1,4.32-4.45c.8-.81,1.61-1.46,3-.83a2.22,2.22,0,0,1,1.06,3Zm-13.41-.5c0-2.17,1.22-2.44,3.87-5.21,1-1.05,3.38-3.88,4.71-3.88a2.31,2.31,0,0,1,2,3.58l-6.62,6.66c-1.61,1.53-4,.42-4-1.15Zm3.75-8c0,.12-4.52,6.52-7,5.37a2.53,2.53,0,0,1-1.26-2.72c.22-.9,2.94-3.38,4-4.48,2.49-2.5,5,.11,4.26,1.83Zm14.1-12.89c3.36,0,2.93,1.2,7,1.2,1.92,0,3.91-.86,4.45-2.34l-.6-.59c-2.4.72-2.85,2.33-7.92.64s-6.11,1.06-8.23,2.93c-1.63,1.45-4.74,1.88-5.92-.27l6.92-7c2.39-2.39,4.09-4.93,9.15-5.05,7.26-.18,14.54,7.76,14.54,14.59,0,4.21-4.56,8.46-5.38,8.5s-8.89-9.19-11.19-11a3.82,3.82,0,0,0-1,.59c.74,1.67,6.72,7.23,8.36,9,.56.62.65.89,1.32,1.67,1.28,1.47,4.22,3.28,2.19,5.47-2.79,3-7.4-6.56-9.81-6.32-.85,1.29,1,2.41,2.84,4.39,1.18,1.3,5.34,4.18,2.75,6.21-1.9,1.48-3.37-.4-4.71-1.74-1-1-1.54-1.53-2.47-2.55-.46-.51-2.67-3.32-3.13-1.52-.12.44-.1.4.25.88,1.21,1.67,5.63,5.18,5.87,6.76.26,1.76-1.85,3.66-4.09,1.51-1.38-1.33-1.88-2.86-4-3.44,0-1.8.67-2.21-.18-3.87-.55-1.06-1.65-1.57-2.53-2.26-.17-1.62.64-2.93-.34-4.37-2.37-3.51-5.69-.88-6.51-.84-1.24-1.57-1.23-2.78-3.89-2.78-3.82,0-3.59,4.56-6.11,2.06-.55-.54-.69-.78-1.19-1.3-2.84-3-4.53-6.45-2.35-11a10.1,10.1,0,0,1,1.87-3.11c2-2.9,6.3-5.51,10-5.51,3.11,0,6.6,2,7.79,4.27-.91,1.54-3.81,4.15-5.31,5.74-4.29,4.54,3.66,6.67,7.51,3.25l.53-.48.13-.12.63-.62.13-.13a4.06,4.06,0,0,1,2.62-1.49Zm-28.47,1.36c0,6.75,3.15,8,5.36,10.6,1.37,1.6-1.54,1.93-.83,5.05a3.63,3.63,0,0,0,1.54,2.25,4.84,4.84,0,0,0,2.08.86l.22.08c1.21.48.33,3.11,3.28,4a8.57,8.57,0,0,0,.84.18l.76.24c.81.3.6,1.53,1.61,2.64,1.74,1.89,2.46.48,3.46,1.8,1.39,1.84.28,3.59,4.89,3.59,1.93,0,4.56-4,5.29-4.5,1.39-1,4.39,2.52,6.71-2.25,1.17-2.39,3.36.13,5.11-4.16,1-2.37,4.15-.71,4.15-5.59,0-1.26-1.62-1.39.17-3.12,4.93-4.77,6.47-9,3-15.55a19,19,0,0,0-7.3-7.73,12.53,12.53,0,0,0-14.89,1.33c-1,.9-.68,1-2,1.45-2.5-2.31-4.61-4.55-9.28-4.55a16.57,16.57,0,0,0-5.42,1.46,16.25,16.25,0,0,0-7.06,6.71,19.42,19.42,0,0,0-1.71,5.21Z",
    transform: "translate(-186.62 -241.03)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "210.05 182.44 220.29 176.06 220.29 121.24 210.05 121.24 210.05 182.44"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 524.48,
    y: 129.62,
    width: 8.9,
    height: 84.82
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosharek);
export default __webpack_public_path__ + "static/media/mosharek.0c6cd1ca5474a4818919f363725304f3.svg";
export { ForwardRef as ReactComponent };